msgid ""
msgstr ""
"POT-Creation-Date: 2025-10-14 12:15+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "“{description}”"
msgstr "“{description}”"

msgid "({freeMembers} free)"
msgstr "({freeMembers} free)"

msgid "(expired today)"
msgstr "(expired today)"

msgid "(expiring today)"
msgstr "(expiring today)"

msgid "(Recycle bin)"
msgstr "(Recycle bin)"

msgid "(total {loginCount})"
msgstr "(total {loginCount})"

msgid "(total {userCount})"
msgstr "(total {userCount})"

#. placeholder {0}: -remainingTrialDays
msgid "{0, plural, one {(expired # day ago)} other {(expired # days ago)}}"
msgstr "{0, plural, one {(expired # day ago)} other {(expired # days ago)}}"

#. placeholder {0}: accounts.length
msgid "{0, plural, one {# Account} other {# Accounts}}"
msgstr "{0, plural, one {# Account} other {# Accounts}}"

#. placeholder {0}: childOrganization.delegatedAdmins.length
#. placeholder {0}: delegatedAdmins.length
msgid "{0, plural, one {# admin (delegated)} other {# admins (delegated)}}"
msgstr "{0, plural, one {# admin (delegated)} other {# admins (delegated)}}"

#. placeholder {0}: apps.length
msgid "{0, plural, one {# App/Platform} other {# Apps/Platforms}}"
msgstr "{0, plural, one {# App/Platform} other {# Apps/Platforms}}"

#. placeholder {0}: mergedBreaches.length
msgid "{0, plural, one {# Breach} other {# Breaches}}"
msgstr "{0, plural, one {# Breach} other {# Breaches}}"

#. placeholder {0}: events?.totalCount ?? 0
msgid "{0, plural, one {# event} other {# events}}"
msgstr "{0, plural, one {# event} other {# events}}"

#. placeholder {0}: sortedChildOrgs.length
msgid "{0, plural, one {# Organization} other {# Organizations}}"
msgstr "{0, plural, one {# Organization} other {# Organizations}}"

#. placeholder {0}: Object.entries(filteredRolesWithCount).length
msgid "{0, plural, one {# Role} other {# Roles}}"
msgstr "{0, plural, one {# Role} other {# Roles}}"

#. placeholder {0}: invalidEmailUserLines.length
#. placeholder {1}: invalidEmailUserLines.length
#. placeholder {2}: invalidEmailUserLines.join(', ')
msgid "{0, plural, one {# row} other {# rows}} skipped due to invalid email. {1, plural, one {Line number} other {Line numbers}}: {2}"
msgstr "{0, plural, one {# row} other {# rows}} skipped due to invalid email. {1, plural, one {Line number} other {Line numbers}}: {2}"

#. placeholder {0}: syncedGroups.length
msgid "{0, plural, one {# synchronized group} other {# synchronized groups}}"
msgstr "{0, plural, one {# synchronized group} other {# synchronized groups}}"

#. placeholder {0}: blockedUsers.length
msgid "{0, plural, one {# user must be enabled in Microsoft Entra before sending a start code} other {# users must be enabled in Microsoft Entra before sending a start code}}"
msgstr "{0, plural, one {# user must be enabled in Microsoft Entra before sending a start code} other {# users must be enabled in Microsoft Entra before sending a start code}}"

#. placeholder {0}: (csv.users && Object.keys(csv.users).length) ?? 0
#. placeholder {0}: (googleWorkspace.users && Object.keys(googleWorkspace.users).length) ?? 0
#. placeholder {0}: entra.userCount ?? 0
msgid "{0, plural, one {# user} other {# users}}"
msgstr "{0, plural, one {# user} other {# users}}"

#. placeholder {0}: selectedUsers.size
msgid "{0, plural, one {# user} other {# users}} selected"
msgstr "{0, plural, one {# user} other {# users}} selected"

#. placeholder {0}: users.length
msgid "{0, plural, one {Cannot remove user} other {Cannot remove users}}"
msgstr "{0, plural, one {Cannot remove user} other {Cannot remove users}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Create new start code} other {Create # new start codes}}"
msgstr "{0, plural, one {Create new start code} other {Create # new start codes}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Creating new start code} other {Creating new start codes}}"
msgstr "{0, plural, one {Creating new start code} other {Creating new start codes}}"

#. placeholder {0}: loginIds.length
msgid "{0, plural, one {Delete # entry?} other {Delete # entries?}}"
msgstr "{0, plural, one {Delete # entry?} other {Delete # entries?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect login device for this user?} other {Disconnect login device for # users?}}"
msgstr "{0, plural, one {Disconnect login device for this user?} other {Disconnect login device for # users?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect login device} other {Disconnect # login devices}}"
msgstr "{0, plural, one {Disconnect login device} other {Disconnect # login devices}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect phone for this user?} other {Disconnect phone for # users?}}"
msgstr "{0, plural, one {Disconnect phone for this user?} other {Disconnect phone for # users?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect phone} other {Disconnect # phones}}"
msgstr "{0, plural, one {Disconnect phone} other {Disconnect # phones}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect security key for this user?} other {Disconnect security key for # users?}}"
msgstr "{0, plural, one {Disconnect security key for this user?} other {Disconnect security key for # users?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect security key} other {Disconnect # security keys}}"
msgstr "{0, plural, one {Disconnect security key} other {Disconnect # security keys}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect user} other {Disconnect # users}}"
msgstr "{0, plural, one {Disconnect user} other {Disconnect # users}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnecting this account conflicts with another account that has the same email address.} other {Disconnecting some of these accounts conflicts with another account that has the same email address.}}"
msgstr "{0, plural, one {Disconnecting this account conflicts with another account that has the same email address.} other {Disconnecting some of these accounts conflicts with another account that has the same email address.}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnecting this account would result in a managed organization being left without an admin.} other {Disconnecting some of these accounts would result in a managed organization being left without an admin.}}"
msgstr "{0, plural, one {Disconnecting this account would result in a managed organization being left without an admin.} other {Disconnecting some of these accounts would result in a managed organization being left without an admin.}}"

#. placeholder {0}: loginMoveInfos.filter((lmi) => canMoveLoginsToVault([lmi], targetVault)).length
#. placeholder {1}: targetVault.label
#. placeholder {2}: targetVault.label
msgid "{0, plural, one {Move # login to {1}} other {Move # logins to {2}}}"
msgstr "{0, plural, one {Move # login to {1}} other {Move # logins to {2}}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {Remove # user?} other {Remove # users?}}"
msgstr "{0, plural, one {Remove # user?} other {Remove # users?}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {Remove # user} other {Remove # users}}"
msgstr "{0, plural, one {Remove # user} other {Remove # users}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Remove user} other {Remove users}}"
msgstr "{0, plural, one {Remove user} other {Remove users}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Resend email invite} other {Resend # email invites}}"
msgstr "{0, plural, one {Resend email invite} other {Resend # email invites}}"

#. placeholder {0}: splitStartCodes.usable.length
#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Revoke start code} other {Revoke # start codes}}"
msgstr "{0, plural, one {Revoke start code} other {Revoke # start codes}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Revoking start code} other {Revoking start codes}}"
msgstr "{0, plural, one {Revoking start code} other {Revoking start codes}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Send email invite} other {Send # email invites}}"
msgstr "{0, plural, one {Send email invite} other {Send # email invites}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Send start code via email} other {Send # start codes via email}}"
msgstr "{0, plural, one {Send start code via email} other {Send # start codes via email}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Sending start code} other {Sending start codes}}"
msgstr "{0, plural, one {Sending start code} other {Sending start codes}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Show start code} other {Show start code for # users}}"
msgstr "{0, plural, one {Show start code} other {Show start code for # users}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Start code created} other {Start codes created}}"
msgstr "{0, plural, one {Start code created} other {Start codes created}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Start code revoked} other {Start codes revoked}}"
msgstr "{0, plural, one {Start code revoked} other {Start codes revoked}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Start code sent} other {Start codes sent}}"
msgstr "{0, plural, one {Start code sent} other {Start codes sent}}"

#. placeholder {0}: 7
msgid "{0, plural, one {The links expire after # day.} other {The links expire after # days.}}"
msgstr "{0, plural, one {The links expire after # day.} other {The links expire after # days.}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {The role for this user cannot be changed.} other {The role for these users cannot be changed.}}"
msgstr "{0, plural, one {The role for this user cannot be changed.} other {The role for these users cannot be changed.}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {This user cannot be removed.} other {These users cannot be removed.}}"
msgstr "{0, plural, one {This user cannot be removed.} other {These users cannot be removed.}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {This user is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.} other {One of these users is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.}}"
msgstr "{0, plural, one {This user is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.} other {One of these users is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {You can connect a new login device for this user afterwards.} other {You can connect a new login device for the users afterwards.}}"
msgstr "{0, plural, one {You can connect a new login device for this user afterwards.} other {You can connect a new login device for the users afterwards.}}"

#. placeholder {0}: manager.email
#. placeholder {0}: parentOrgProfile.email
#. placeholder {0}: user.email
msgid "{0} (You)"
msgstr "{0} (You)"

#. placeholder {0}: keptUsers[0].email ?? t`Unknown user`
msgid "{0} cannot be removed."
msgstr "{0} cannot be removed."

#. placeholder {0}: selectedGroups.length
#. placeholder {1}: groupsList.length
msgid "{0} of {1, plural, one {# group} other {# groups}} selected"
msgstr "{0} of {1, plural, one {# group} other {# groups}} selected"

#. placeholder {0}: keptUsers.length
msgid "{0} users cannot be removed."
msgstr "{0} users cannot be removed."

#. placeholder {0}: singularCandidate.name
msgid "{0} will have full access to this organization."
msgstr "{0} will have full access to this organization."

#. placeholder {0}: vaultMetadata.owner.email
msgid "{0}’s personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "{0}’s personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."

msgid "{activeShareLinkCount, plural, one {There is # active share link.} other {There are # active share links.}}"
msgstr "{activeShareLinkCount, plural, one {There is # active share link.} other {There are # active share links.}}"

msgid "{activeShareSecretCount, plural, one {There is # encrypted link.} other {There are # encrypted links.}}"
msgstr "{activeShareSecretCount, plural, one {There is # encrypted link.} other {There are # encrypted links.}}"

msgid "{amount} / monthly"
msgstr "{amount} / monthly"

msgid "{amount} / yearly"
msgstr "{amount} / yearly"

msgctxt "date-fns format string"
msgid "{atAbsoluteDate}"
msgstr "{atAbsoluteDate}"

msgid "{billableUsers, plural, one {# user} other {# users}}"
msgstr "{billableUsers, plural, one {# user} other {# users}}"

#. placeholder {0}: getOsDescription(t, parsed.os)
msgid "{browserName} on {0}"
msgstr "{browserName} on {0}"

msgid "{c, plural, one {# account count} other {# account counts}}"
msgstr "{c, plural, one {# account count} other {# account counts}}"

msgid "{c, plural, one {# admin (delegated)} other {# admins (delegated)}}"
msgstr "{c, plural, one {# admin (delegated)} other {# admins (delegated)}}"

msgid "{c, plural, one {# event type} other {# event types}}"
msgstr "{c, plural, one {# event type} other {# event types}}"

msgid "{c, plural, one {# group} other {# groups}}"
msgstr "{c, plural, one {# group} other {# groups}}"

msgid "{c, plural, one {# leak check} other {# leak checks}}"
msgstr "{c, plural, one {# leak check} other {# leak checks}}"

msgid "{c, plural, one {# location} other {# locations}}"
msgstr "{c, plural, one {# location} other {# locations}}"

msgid "{c, plural, one {# login location} other {# login locations}}"
msgstr "{c, plural, one {# login location} other {# login locations}}"

msgid "{c, plural, one {# login} other {# logins}}"
msgstr "{c, plural, one {# login} other {# logins}}"

msgid "{c, plural, one {# origin} other {# origins}}"
msgstr "{c, plural, one {# origin} other {# origins}}"

msgid "{c, plural, one {# password strength} other {# password strength}}"
msgstr "{c, plural, one {# password strength} other {# password strength}}"

msgid "{c, plural, one {# policy check} other {# policy checks}}"
msgstr "{c, plural, one {# policy check} other {# policy checks}}"

msgid "{c, plural, one {# role} other {# roles}}"
msgstr "{c, plural, one {# role} other {# roles}}"

msgid "{c, plural, one {# target user} other {# target users}}"
msgstr "{c, plural, one {# target user} other {# target users}}"

msgid "{c, plural, one {# team} other {# teams}}"
msgstr "{c, plural, one {# team} other {# teams}}"

msgid "{c, plural, one {# user} other {# users}}"
msgstr "{c, plural, one {# user} other {# users}}"

msgid "{c, plural, other {# status}}"
msgstr "{c, plural, other {# status}}"

msgid "{connected} connected"
msgstr "{connected} connected"

msgid "{count, plural, one {# user} other {# users}}"
msgstr "{count, plural, one {# user} other {# users}}"

msgid "{disabledCount, plural, other {# disabled}}"
msgstr "{disabledCount, plural, other {# disabled}}"

msgid "{disconnected} not connected"
msgstr "{disconnected} not connected"

msgid "{entraSyncGroupCount, plural, one {# group synchronized} other {# groups synchronized}}"
msgstr "{entraSyncGroupCount, plural, one {# group synchronized} other {# groups synchronized}}"

msgid "{formattedFrom} – {formattedTo}"
msgstr "{formattedFrom} – {formattedTo}"

msgid "{formattedStartDate} to {formattedEndDate}"
msgstr "{formattedStartDate} to {formattedEndDate}"

msgid "{importedUsersCount, plural, one {# user} other {# users}} imported from CSV."
msgstr "{importedUsersCount, plural, one {# user} other {# users}} imported from CSV."

msgid "{label} is disabled on this device"
msgstr "{label} is disabled on this device"

msgid "{loginCount, plural, one {# entry} other {# entries}}"
msgstr "{loginCount, plural, one {# entry} other {# entries}}"

msgid "{loginCount, plural, one {# team login} other {# team logins}}"
msgstr "{loginCount, plural, one {# team login} other {# team logins}}"

msgid "{matchingTeamMemberCount, plural, one {# matching user already is a team member.} other {# matching users already are team members.}}"
msgstr "{matchingTeamMemberCount, plural, one {# matching user already is a team member.} other {# matching users already are team members.}}"

msgid "{memberCount, plural, one {# user} other {# users}}"
msgstr "{memberCount, plural, one {# user} other {# users}}"

msgid "{minutes, plural, one {# minute} other {# minutes}}"
msgstr "{minutes, plural, one {# minute} other {# minutes}}"

msgid "{nonMemberCount, plural, one {# not member} other {# not member}}"
msgstr "{nonMemberCount, plural, one {# not member} other {# not member}}"

msgid "{nonMemberCount, plural, one {Add # user} other {Add # users}}"
msgstr "{nonMemberCount, plural, one {Add # user} other {Add # users}}"

msgid "{nonMemberCount, plural, one {Add} other {Add # users}}"
msgstr "{nonMemberCount, plural, one {Add} other {Add # users}}"

msgid "{nonMemberCount, plural, one {Not member} other {# not member}}"
msgstr "{nonMemberCount, plural, one {Not member} other {# not member}}"

msgid "{organizationName} logo"
msgstr "{organizationName} logo"

msgid "{profileName} (All organization teams)"
msgstr "{profileName} (All organization teams)"

msgid "{profileName} (My teams)"
msgstr "{profileName} (My teams)"

#. placeholder {0}: userCount - profileUserCount
msgid "{profileUserCount, plural, =1 {# account} other {# accounts}}, {0, plural, =1 {# user} other {# users}} without account"
msgstr "{profileUserCount, plural, =1 {# account} other {# accounts}}, {0, plural, =1 {# user} other {# users}} without account"

msgid "{recentlyPairedSessionName} was set up successfully"
msgstr "{recentlyPairedSessionName} was set up successfully"

msgid "{remainingTrialDays, plural, one {(# day remaining)} other {(# days remaining)}}"
msgstr "{remainingTrialDays, plural, one {(# day remaining)} other {(# days remaining)}}"

msgid "{revisionTimeEl} – by {editProfileEmail}"
msgstr "{revisionTimeEl} – by {editProfileEmail}"

msgid "{selectedLoginCount, plural, one {Delete entry} other {Delete entries}}"
msgstr "{selectedLoginCount, plural, one {Delete entry} other {Delete entries}}"

msgid "{selectedLoginCount, plural, one {Restore entry} other {Restore entries}}"
msgstr "{selectedLoginCount, plural, one {Restore entry} other {Restore entries}}"

msgid "{selectedLoginCount} of {filteredLoginCount} entries selected"
msgstr "{selectedLoginCount} of {filteredLoginCount} entries selected"

msgid "{selectedUserCount, plural, one {Activate account in heylogin} other {Activate # accounts in heylogin}}"
msgstr "{selectedUserCount, plural, one {Activate account in heylogin} other {Activate # accounts in heylogin}}"

msgid "{selectedUserCount} of {filteredUserCount, plural, one {# user} other {# users}} selected"
msgstr "{selectedUserCount} of {filteredUserCount, plural, one {# user} other {# users}} selected"

msgid "{selectionSize, plural, one {# login selected} other {# logins selected}}"
msgstr "{selectionSize, plural, one {# login selected} other {# logins selected}}"

msgid "{title} (CSV)"
msgstr "{title} (CSV)"

msgid "{totalTrialDays}-day test phase"
msgstr "{totalTrialDays}-day test phase"

msgid "{trialDurationDays, plural, one {Trial ends tomorrow} other {Trial ends in # days}}"
msgstr "{trialDurationDays, plural, one {Trial ends tomorrow} other {Trial ends in # days}}"

msgid "{userCount, plural, one {(# user)} other {(# users)}}"
msgstr "{userCount, plural, one {(# user)} other {(# users)}}"

msgid "{userCount, plural, one {# guest member} other {# guest members}}"
msgstr "{userCount, plural, one {# guest member} other {# guest members}}"

msgid "{userCount, plural, one {# team member} other {# team members}}"
msgstr "{userCount, plural, one {# team member} other {# team members}}"

msgid "{userCount, plural, one {# user} other {# users}}"
msgstr "{userCount, plural, one {# user} other {# users}}"

msgid "{withStartCode} not connected (waiting for registration)"
msgstr "{withStartCode} not connected (waiting for registration)"

msgid "*All prices plus VAT"
msgstr "*All prices plus VAT"

msgid "/user/month*"
msgstr "/user/month*"

msgid "#@$"
msgstr "#@$"

msgid "< 100%"
msgstr "< 100%"

msgid "< 50%"
msgstr "< 50%"

msgid "<0>Install heylogin Autotype <1/></0> on your system."
msgstr "<0>Install heylogin Autotype <1/></0> on your system."

msgid "<0>Note:</0> If the import doesn't work, try changing your StickyPassword language to English before exporting."
msgstr "<0>Note:</0> If the import doesn't work, try changing your StickyPassword language to English before exporting."

msgid "<0>Personal Logins</0> stores logins of your organization only used by you. Admins <1>cannot</1> see passwords here."
msgstr "<0>Personal Logins</0> stores logins of your organization only used by you. Admins <1>cannot</1> see passwords here."

msgid "€3.99"
msgstr "€3.99"

msgid "€4.99"
msgstr "€4.99"

msgid "0{nonBreakingHyphen}9"
msgstr "0{nonBreakingHyphen}9"

msgid "1. Configure sync"
msgstr "1. Configure sync"

msgid "1. Connect to Entra"
msgstr "1. Connect to Entra"

msgid "100%"
msgstr "100%"

msgid "100% GDPR-compliant and confidential handling"
msgstr "100% GDPR-compliant and confidential handling"

msgid "1Password"
msgstr "1Password"

msgid "2-factor automation (TOTP)"
msgstr "2-factor automation (TOTP)"

msgid "2. Configure sync"
msgstr "2. Configure sync"

msgid "2. Review sync settings"
msgstr "2. Review sync settings"

msgid "3. Review sync settings"
msgstr "3. Review sync settings"

msgid "A – Z"
msgstr "A – Z"

msgid "A group can only be removed if it contains no logins."
msgstr "A group can only be removed if it contains no logins."

msgid "A label name cannot contain a slash"
msgstr "A label name cannot contain a slash"

msgid "A second admin can recover your account if you lose access to your login devices."
msgstr "A second admin can recover your account if you lose access to your login devices."

msgid "a{nonBreakingHyphen}z"
msgstr "a{nonBreakingHyphen}z"

msgid "A{nonBreakingHyphen}Z"
msgstr "A{nonBreakingHyphen}Z"

msgid "Account"
msgstr "Account"

msgid "Account balances"
msgstr "Account balances"

msgid "Account count"
msgstr "Account count"

msgid "Account holder"
msgstr "Account holder"

msgid "Account name"
msgstr "Account name"

msgctxt "KeeperImport"
msgid "Account number"
msgstr "Account number"

msgctxt "KeeperImport"
msgid "Account type"
msgstr "Account type"

msgid "Accounts"
msgstr "Accounts"

msgid "Accounts on this device"
msgstr "Accounts on this device"

msgid "Action canceled"
msgstr "Action canceled"

msgid "Action confirmed"
msgstr "Action confirmed"

msgid "Activate"
msgstr "Activate"

msgid "Activate “heylogin – Password Manager”"
msgstr "Activate “heylogin – Password Manager”"

msgid "Activate on this device"
msgstr "Activate on this device"

msgid "Activate plan"
msgstr "Activate plan"

msgid "Activate plan for “{organizationName}”"
msgstr "Activate plan for “{organizationName}”"

msgid "Activate plan: heylogin Enterprise MSP"
msgstr "Activate plan: heylogin Enterprise MSP"

msgid "Activate the heylogin Enterprise MSP plan for this customer."
msgstr "Activate the heylogin Enterprise MSP plan for this customer."

msgid "Activating {selectedUserCount, plural, one {account} other {accounts}}…"
msgstr "Activating {selectedUserCount, plural, one {account} other {accounts}}…"

msgid "Activating the <0>heylogin Enterprise MSP</0> plan for this organization is a billable event."
msgstr "Activating the <0>heylogin Enterprise MSP</0> plan for this organization is a billable event."

msgid "Active"
msgstr "Active"

msgid "Active links"
msgstr "Active links"

msgid "Active until"
msgstr "Active until"

msgid "Active user"
msgstr "Active user"

msgid "Add"
msgstr "Add"

msgid "Add admin (delegated)"
msgstr "Add admin (delegated)"

msgid "Add description"
msgstr "Add description"

msgid "Add filter"
msgstr "Add filter"

msgid "Add icon"
msgstr "Add icon"

msgid "Add label…"
msgstr "Add label…"

msgid "Add link and copy"
msgstr "Add link and copy"

msgid "Add login manually"
msgstr "Add login manually"

msgid "Add login to"
msgstr "Add login to"

msgid "Add logins manually"
msgstr "Add logins manually"

msgid "Add logo"
msgstr "Add logo"

msgid "Add member"
msgstr "Add member"

msgid "Add member to {targetVaultName}"
msgstr "Add member to {targetVaultName}"

msgid "Add new organization member to team"
msgstr "Add new organization member to team"

msgid "Add new user"
msgstr "Add new user"

msgid "Add new user to organization"
msgstr "Add new user to organization"

msgid "Add organization member"
msgstr "Add organization member"

msgid "Add recipient profile picture"
msgstr "Add recipient profile picture"

msgid "Add service user"
msgstr "Add service user"

msgid "Add team logins"
msgstr "Add team logins"

msgid "Add the app name (e.g. Teams.exe) to the respective login in heylogin, just like a website. You can use the keyboard shortcut above to find the app name."
msgstr "Add the app name (e.g. Teams.exe) to the respective login in heylogin, just like a website. You can use the keyboard shortcut above to find the app name."

msgid "Add to Chrome"
msgstr "Add to Chrome"

msgid "Add to Firefox"
msgstr "Add to Firefox"

msgid "Add to Opera"
msgstr "Add to Opera"

msgid "Add user"
msgstr "Add user"

msgid "Add user to team"
msgstr "Add user to team"

msgid "Add your contact information"
msgstr "Add your contact information"

msgid "Adding…"
msgstr "Adding…"

msgid "Additional columns will be imported as well and can be used to filter users"
msgstr "Additional columns will be imported as well and can be used to filter users"

msgid "Additional login devices"
msgstr "Additional login devices"

msgid "Additional security key"
msgstr "Additional security key"

msgctxt "KeeperImport"
msgid "Address"
msgstr "Address"

msgid "Address book contacts"
msgstr "Address book contacts"

msgid "Adjust domains?"
msgstr "Adjust domains?"

msgid "Admin"
msgstr "Admin"

msgid "Admin (delegated)"
msgstr "Admin (delegated)"

msgid "Admin access"
msgstr "Admin access"

msgid "Admins (delegated)"
msgstr "Admins (delegated)"

msgid "Affected accounts:"
msgstr "Affected accounts:"

msgid "Affected data:"
msgstr "Affected data:"

msgid "After enabling the user in Entra, the user can be reconnected"
msgstr "After enabling the user in Entra, the user can be reconnected"

msgid "After that tap “Manage Extensions”"
msgstr "After that tap “Manage Extensions”"

msgid "Age groups"
msgstr "Age groups"

msgid "Age recipient"
msgstr "Age recipient"

#. placeholder {0}: shareSecretData.ageRecipient
msgid "Age recipient: <0>{0}</0>"
msgstr "Age recipient: <0>{0}</0>"

msgid "Ages"
msgstr "Ages"

msgid "all accessible logins"
msgstr "all accessible logins"

msgid "All delegated admins are in this team automatically."
msgstr "All delegated admins are in this team automatically."

msgid "All functions of Business"
msgstr "All functions of Business"

msgid "All functions of Free"
msgstr "All functions of Free"

msgid "All groups already synchronized"
msgstr "All groups already synchronized"

msgid "All login activities at one glance"
msgstr "All login activities at one glance"

#. placeholder {0}: profileInfo.label
msgid "All logins in the organization “{0}” will no longer be accessible to you."
msgstr "All logins in the organization “{0}” will no longer be accessible to you."

msgid "All logins in the organization will be deleted."
msgstr "All logins in the organization will be deleted."

msgid "All members of the organization are also members of this team."
msgstr "All members of the organization are also members of this team."

msgid "All organization members already are delegated admins of this managed organization."
msgstr "All organization members already are delegated admins of this managed organization."

msgid "All organization users are in this team automatically."
msgstr "All organization users are in this team automatically."

msgid "All personal logins will be deleted."
msgstr "All personal logins will be deleted."

msgid "All teams"
msgstr "All teams"

msgid "All user accounts in the organization will be removed."
msgstr "All user accounts in the organization will be removed."

msgid "All Users"
msgstr "All Users"

msgid "Allow access on all pages"
msgstr "Allow access on all pages"

msgid "Already extended"
msgstr "Already extended"

msgid "An account has been prepared for this email address in an organization. Please install the heylogin app on your phone or use a security key to continue."
msgstr "An account has been prepared for this email address in an organization. Please install the heylogin app on your phone or use a security key to continue."

msgid "An admin of the managing organization needs to remove the last delegated admin from this organization."
msgstr "An admin of the managing organization needs to remove the last delegated admin from this organization."

msgid "An email invite will be sent to every person"
msgstr "An email invite will be sent to every person"

msgid "an hour"
msgstr "an hour"

msgid "An internal error occurred, please <0>contact support</0>"
msgstr "An internal error occurred, please <0>contact support</0>"

msgid "An overview of your login devices. You can connect new devices for unlocking heylogin here."
msgstr "An overview of your login devices. You can connect new devices for unlocking heylogin here."

msgid "An unknown error occurred, please <0>contact support</0>"
msgstr "An unknown error occurred, please <0>contact support</0>"

msgid "Android App (Play Store Beta)"
msgstr "Android App (Play Store Beta)"

msgid "Android or iPhone"
msgstr "Android or iPhone"

msgid "Another login inbox with the same email is already enabled. Disable it to enable this login inbox."
msgstr "Another login inbox with the same email is already enabled. Disable it to enable this login inbox."

msgctxt "KeeperImport"
msgid "Answer"
msgstr "Answer"

msgid "App overview"
msgstr "App overview"

msgid "App/Platform"
msgstr "App/Platform"

msgid "Apple Passwords"
msgstr "Apple Passwords"

msgctxt "KeeperImport"
msgid "Application title"
msgstr "Application title"

msgid "Apply"
msgstr "Apply"

msgid "Apply as filter"
msgstr "Apply as filter"

msgid "Appointments"
msgstr "Appointments"

msgid "Apps"
msgstr "Apps"

msgid "Apps installed on devices"
msgstr "Apps installed on devices"

msgid "Assign team access to others"
msgstr "Assign team access to others"

msgid "Assign team access to self"
msgstr "Assign team access to self"

msgid "Assigned roles provide clarity and structure, as not every employee requires the same level of administrative freedom. heylogin offers a range of roles with different permissions to meet these needs."
msgstr "Assigned roles provide clarity and structure, as not every employee requires the same level of administrative freedom. heylogin offers a range of roles with different permissions to meet these needs."

msgid "Astrological signs"
msgstr "Astrological signs"

msgid "At least one user must be admin. It is recommended to have at least two admins."
msgstr "At least one user must be admin. It is recommended to have at least two admins."

msgid "Attach screenshot (Images only, max 3 MB)"
msgstr "Attach screenshot (Images only, max 3 MB)"

msgid "Audio recordings"
msgstr "Audio recordings"

msgid "Audit log"
msgstr "Audit log"

msgid "Auth tokens"
msgstr "Auth tokens"

msgid "Auto save with heylogin"
msgstr "Auto save with heylogin"

msgid "Automatic provisioning"
msgstr "Automatic provisioning"

msgid "Automatically create users in heylogin from selected Entra groups"
msgstr "Automatically create users in heylogin from selected Entra groups"

msgid "Automatically disconnect users in heylogin that are disabled in Entra"
msgstr "Automatically disconnect users in heylogin that are disabled in Entra"

msgid "Autotype"
msgstr "Autotype"

msgid "Autotype for Windows"
msgstr "Autotype for Windows"

msgid "Autotype instruction screenshot"
msgstr "Autotype instruction screenshot"

msgid "Autotype is not installed"
msgstr "Autotype is not installed"

msgid "Autotype is outdated"
msgstr "Autotype is outdated"

msgctxt "KeeperImport"
msgid "Autotype keystrokes"
msgstr "Autotype keystrokes"

msgid "Available Entra groups"
msgstr "Available Entra groups"

msgid "Avatars"
msgstr "Avatars"

msgid "Back"
msgstr "Back"

msgid "Backup Code"
msgstr "Backup Code"

msgctxt "KeeperImport"
msgid "Bank account"
msgstr "Bank account"

msgid "Bank account numbers"
msgstr "Bank account numbers"

msgid "Beauty ratings"
msgstr "Beauty ratings"

msgid "Beta"
msgstr "Beta"

msgid "Beta program"
msgstr "Beta program"

msgid "BIC/SWIFT code"
msgstr "BIC/SWIFT code"

msgid "Billing"
msgstr "Billing"

msgid "Billing date"
msgstr "Billing date"

msgid "Billing email"
msgstr "Billing email"

msgid "Biometric data"
msgstr "Biometric data"

msgid "Bios"
msgstr "Bios"

msgctxt "KeeperImport"
msgid "Birth date"
msgstr "Birth date"

msgid "Bitwarden"
msgstr "Bitwarden"

msgid "Book appointment"
msgstr "Book appointment"

msgid "Breach date:"
msgstr "Breach date:"

msgid "Browse to the location where you want to save the new CSV file, and then click “Save”."
msgstr "Browse to the location where you want to save the new CSV file, and then click “Save”."

msgid "Browser Extensions"
msgstr "Browser Extensions"

msgid "Browser user agent details"
msgstr "Browser user agent details"

msgid "Browsing histories"
msgstr "Browsing histories"

msgid "Business"
msgstr "Business"

msgid "Buy additional licenses"
msgstr "Buy additional licenses"

msgid "Buying big? Contact our sales team for better deals!"
msgstr "Buying big? Contact our sales team for better deals!"

msgid "Buying preferences"
msgstr "Buying preferences"

msgid "Can assign delegated admins to all managed organizations"
msgstr "Can assign delegated admins to all managed organizations"

msgid "Can connect new devices"
msgstr "Can connect new devices"

msgid "Can manage users, roles and integrations"
msgstr "Can manage users, roles and integrations"

msgid "Can manage users, roles, integrations and child organizations"
msgstr "Can manage users, roles, integrations and child organizations"

msgid "Can unlock devices"
msgstr "Can unlock devices"

msgid "Can unlock this device"
msgstr "Can unlock this device"

msgid "Can use and edit logins and manage members."
msgstr "Can use and edit logins and manage members."

msgid "Can use and edit logins."
msgstr "Can use and edit logins."

msgid "Can use and view logins."
msgstr "Can use and view logins."

msgid "Can use logins. Passwords are hidden."
msgstr "Can use logins. Passwords are hidden."

msgid "Can view managed organizations the user is not delegated admin in"
msgstr "Can view managed organizations the user is not delegated admin in"

msgid "Can't change: Team must have at least one admin."
msgstr "Can't change: Team must have at least one admin."

msgid "Cancel"
msgstr "Cancel"

msgid "Cancel and back"
msgstr "Cancel and back"

msgid "Cancel change"
msgstr "Cancel change"

msgid "Cancel deletion"
msgstr "Cancel deletion"

msgid "Cancel your license first to convert to a managed organization."
msgstr "Cancel your license first to convert to a managed organization."

msgid "Cancelled"
msgstr "Cancelled"

msgid "Car ownership statuses"
msgstr "Car ownership statuses"

msgid "Card holder"
msgstr "Card holder"

msgid "Career levels"
msgstr "Career levels"

msgid "Cellular network names"
msgstr "Cellular network names"

msgid "Change billing email"
msgstr "Change billing email"

msgid "Change Email"
msgstr "Change Email"

msgid "Change email address"
msgstr "Change email address"

msgid "Change icon"
msgstr "Change icon"

msgid "Change keyboard shortcut"
msgstr "Change keyboard shortcut"

msgid "Change logo"
msgstr "Change logo"

msgid "Change plan"
msgstr "Change plan"

msgid "Change role"
msgstr "Change role"

msgid "Change settings"
msgstr "Change settings"

msgid "Changed:"
msgstr "Changed:"

msgid "Changed: {joinedDifferences}"
msgstr "Changed: {joinedDifferences}"

#. placeholder {0}: differences.length
msgid "Changed: <0>{0, plural, one {# field} other {# fields}}</0>"
msgstr "Changed: <0>{0, plural, one {# field} other {# fields}}</0>"

#. placeholder {0}: values.email
msgid "Changing your email address to {0} would result in conflicting login inboxes, as a login inbox exists in this account and in another account with that email address. You can only have one login inbox per email address."
msgstr "Changing your email address to {0} would result in conflicting login inboxes, as a login inbox exists in this account and in another account with that email address. You can only have one login inbox per email address."

msgid "Charitable donations"
msgstr "Charitable donations"

msgid "Chat logs"
msgstr "Chat logs"

msgid "Check again"
msgstr "Check again"

msgid "Check your e-mails for the latest verification link, or request a new one."
msgstr "Check your e-mails for the latest verification link, or request a new one."

msgid "Checking logins for policy compliance"
msgstr "Checking logins for policy compliance"

msgid "Checking start code…"
msgstr "Checking start code…"

#. placeholder {0}: import { plural, t } from '@lingui/core/macro'; import { Trans } from '@lingui/react/macro'; import classNames from 'classnames'; import React, { useCallback, useEffect, useMemo, useState } from 'react'; import { Email, ProfileId } from 'backend-client-web'; import { InlineProgressButton, Loading, NativeSelect, LinkButton } from 'client-web-sdk'; import Modal from 'src/components/modal/Modal'; import { ReactComponent as NextIcon } from './next.svg'; import { ReactComponent as PreviousIcon } from './previous.svg'; import styles from './StartCodeModal.module.css'; type ProfileStartCodes = { profileId: ProfileId; email: Email | undefined; startCode: string | undefined; }[]; export default function StartCodeModal({ isOpen, close, profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, }: { isOpen: boolean; close: () => void; profileStartCodes?: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; }) { const [showGuide, setShowGuide] = useState(false); return ( <Modal isOpen={isOpen} onRequestClose={close} width={showGuide ? '42rem' : '24rem'} className={classNames(styles.Modal, showGuide && styles.showGuide)} fullscreenClassName={styles.fullscreen} windowedClassName={styles.windowed} contentClassName={styles.ModalContent} > {profileStartCodes ? <ProfileStartCodeDisplay showGuide={showGuide} setShowGuide={setShowGuide} profileStartCodes={profileStartCodes} renewStartCodes={renewStartCodes} revokeStartCodes={revokeStartCodes} sendStartCodeEmails={sendStartCodeEmails} /> : <Loading />} </Modal> ); } function ProfileStartCodeDisplay({ showGuide, setShowGuide, profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, }: { showGuide: boolean; setShowGuide: React.Dispatch<React.SetStateAction<boolean>>; profileStartCodes: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; }) { return ( <div className={styles.Sections}> <StartCodeSection profileStartCodes={profileStartCodes} renewStartCodes={renewStartCodes} revokeStartCodes={revokeStartCodes} sendStartCodeEmails={sendStartCodeEmails} showGuide={showGuide} setShowGuide={setShowGuide} /> <GuideSection hidden={!showGuide} /> </div> ); } function GuideSection({ hidden }: { hidden: boolean }) { const [guide, setGuide] = useState<'phone' | 'securityKey'>('phone'); const securityKeyUri = `${window.location.host}/start`; return ( <section className={styles.GuideSection} aria-hidden={hidden}> <p className={styles.GuideChooser}> <label> <Trans>Guide for:</Trans>{' '} <NativeSelect className={styles.GuideSelect} value={guide} onChange={(e) => setGuide(e.currentTarget.value as any)} > <option value="phone">{t`Phone`}</option> <option value="securityKey">{t`Security Key`}</option> </NativeSelect> </label> </p> <ol className={styles.SetupSteps}> {guide === 'phone' ? <> <li> <Trans> Download the <strong>heylogin app</strong> </Trans> </li> <li> <Trans> Enter <strong>company email</strong> </Trans> </li> <li> <Trans> Enter <strong>start code</strong> </Trans> </li> </> : <> <li> <Trans> Open <strong>{securityKeyUri}</strong> in a desktop browser </Trans> </li> <li> <Trans> {/* Separate translation for inner string so it always matches the label in the actual UI in translation */} Choose <strong>“{t`Use a security key`}”</strong> </Trans> </li> <li> <Trans> Enter <strong>email</strong> and <strong>start code</strong> </Trans> </li> </> } </ol> </section> ); } function StartCodeSection({ profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, showGuide, setShowGuide, }: { profileStartCodes: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; showGuide: boolean; setShowGuide: React.Dispatch<React.SetStateAction<boolean>>; }) { const { visibleProfile, showPagination, profileIndex, changePage } = useProfilePagination(profileStartCodes); const [splitStartCodes, setSplitStartCodes] = useState({ usable: profileStartCodes, revoked: [] as ProfileStartCodes, }); const updateStartCodes = useCallback((scs: ProfileStartCodes) => { const usable: ProfileStartCodes = []; const revoked: ProfileStartCodes = []; for (const sc of scs) { if (sc.startCode) { usable.push(sc); } else { revoked.push(sc); } } setSplitStartCodes({ usable, revoked }); }, []); // Allow temporarily pausing start code updates, so we can finish the success animation with the // old state before the new state is shown const [startCodeUpdateHold, setStartCodeUpdateHold] = useState(false); useEffect(() => { if (startCodeUpdateHold) { return; } updateStartCodes(profileStartCodes); }, [profileStartCodes, startCodeUpdateHold, updateStartCodes]); if (!visibleProfile) { return <Loading />; } return ( <section className={styles.StartCodeSection}> <div className={styles.Subsection}> <p className={styles.StartCodeFor}> <Trans>Start code for:</Trans> </p> <p className={styles.StartCodeEmail}>{visibleProfile.email ?? t`Service User`}</p> </div> <div className={styles.Subsection}> <p className={classNames( styles.StartCode, visibleProfile.startCode === undefined && styles.placeholder, )} > <strong>{visibleProfile.startCode ?? 'XX-XXXX'}</strong> </p> {showPagination && ( <p className={styles.Pagination}> <button className={styles.IconButton} onClick={() => changePage(-1)} disabled={profileIndex === 0} > <PreviousIcon title={t`Previous`} /> </button> <span> <Trans> Start code {profileIndex + 1} of {profileStartCodes.length} </Trans> </span> <button className={styles.IconButton} onClick={() => changePage(1)} disabled={profileIndex === profileStartCodes.length - 1} > <NextIcon title={t`Next`} /> </button> </p> )} </div> <div className={styles.Subsection}> {splitStartCodes.usable.length > 0 && ( <> <InlineProgressButton className={styles.RevokeStartCode} performAction={async () => { setStartCodeUpdateHold(true); try { await revokeStartCodes(splitStartCodes.usable.map((p) => p.profileId)); } finally { setTimeout(() => setStartCodeUpdateHold(false), 1500); } }} getErrorLabel={() => t`Failed to revoke`} initialLabel={plural(splitStartCodes.usable.length, { one: 'Revoke start code', other: 'Revoke # start codes', })} inProgressLabel={plural(splitStartCodes.usable.length, { one: 'Revoking start code', other: 'Revoking start codes', })} successLabel={plural(splitStartCodes.usable.length, { one: 'Start code revoked', other: 'Start codes revoked', })} successRedoActionLabel={plural(splitStartCodes.usable.length, { one: 'Revoke start code', other: 'Revoke # start codes', })} errorRedoActionLabel={t`Retry`} /> {sendStartCodeEmails && ( <InlineProgressButton className={styles.SendMail} performAction={async () => { await sendStartCodeEmails(splitStartCodes.usable.map((p) => p.profileId)); }} getErrorLabel={() => t`Failed to send`} initialLabel={plural(splitStartCodes.usable.length, { one: 'Send start code via email', other: 'Send # start codes via email', })} inProgressLabel={plural(splitStartCodes.usable.length, { one: 'Sending start code', other: 'Sending start codes', })} successLabel={plural(splitStartCodes.usable.length, { one: 'Start code sent', other: 'Start codes sent', })} successRedoActionLabel={t`Send again`} errorRedoActionLabel={t`Retry`} /> )} </> )} {splitStartCodes.revoked.length > 0 && ( <InlineProgressButton className={styles.RevokeStartCode} performAction={async () => { setStartCodeUpdateHold(true); try { await renewStartCodes(splitStartCodes.revoked.map((p) => p.profileId)); } finally { setTimeout(() => setStartCodeUpdateHold(false), 1500); } }} getErrorLabel={() => t`Failed to renew`} initialLabel={plural(splitStartCodes.revoked.length, { one: 'Create new start code', other: 'Create # new start codes', })} inProgressLabel={plural(splitStartCodes.revoked.length, { one: 'Creating new start code', other: 'Creating new start codes', })} successLabel={plural(splitStartCodes.revoked.length, { one: 'Start code created', other: 'Start codes created', })} successRedoActionLabel={plural(splitStartCodes.revoked.length, { one: 'Create new start code', other: 'Create # new start codes', })} errorRedoActionLabel={t`Retry`} /> )} <LinkButton className={styles.Instructions} onClick={() => setShowGuide((g) => !g)}> {showGuide ? <Trans>Hide instructions</Trans> : <Trans>Show instructions</Trans>} </LinkButton> </div> </section> ); } function useProfilePagination(profileStartCodes: ProfileStartCodes) { const [visibleProfileId, setVisibleProfileId] = useState<ProfileId>(); const profileIndex = useMemo(() => { if (!visibleProfileId) { return 0; } const idx = profileStartCodes.findIndex((s) => s.profileId === visibleProfileId); if (idx === -1) { return 0; } return idx; }, [visibleProfileId, profileStartCodes]); const changePage = useCallback( (direction: -1 | 1) => { const newProfileIndex = clamp(0, profileIndex + direction, profileStartCodes.length - 1); const newVisibleProfileId = profileStartCodes[newProfileIndex]?.profileId; setVisibleProfileId(newVisibleProfileId); }, [profileIndex, profileStartCodes], ); const visibleProfile = profileIndex < profileStartCodes.length ? profileStartCodes[profileIndex] : undefined; return { visibleProfile, showPagination: profileStartCodes.length > 1, profileIndex, changePage }; } function clamp(min: number, num: number, max: number) { return Math.max(min, Math.min(max, num)); } 
msgid "Choose <0>“{0}”</0>"
msgstr "Choose <0>“{0}”</0>"

msgid "Choose a file name and click “Save”."
msgstr "Choose a file name and click “Save”."

msgid "Chrome Extension (Beta)"
msgstr "Chrome Extension (Beta)"

msgctxt "Storybook"
msgid "Chrome on macOS"
msgstr "Chrome on macOS"

msgid "Citizenship statuses"
msgstr "Citizenship statuses"

msgctxt "KeeperImport"
msgid "City"
msgstr "City"

msgid "Clear"
msgstr "Clear"

msgid "Clear selection"
msgstr "Clear selection"

msgid "Click “Export passwords...”."
msgstr "Click “Export passwords...”."

msgctxt "EdgeImportGuide"
msgid "Click “Export passwords...”."
msgstr "Click “Export passwords...”."

msgid "Click “Export...”."
msgstr "Click “Export...”."

msgctxt "FirefoxImportGuide"
msgid "Click “Export...”."
msgstr "Click “Export...”."

msgid "Click “File” in the top left corner."
msgstr "Click “File” in the top left corner."

msgid "Click “Save”."
msgstr "Click “Save”."

msgid "Click on “Export”."
msgstr "Click on “Export”."

msgid "Click on “File”."
msgstr "Click on “File”."

msgid "Click on the Save-Icon."
msgstr "Click on the Save-Icon."

msgid "Click the 3 dots at the top right."
msgstr "Click the 3 dots at the top right."

msgid "Click the 3 dots in the upper right corner to open the menu."
msgstr "Click the 3 dots in the upper right corner to open the menu."

msgid "Click the 3 dots next to “Saved Passwords”."
msgstr "Click the 3 dots next to “Saved Passwords”."

msgctxt "EdgeImportGuide"
msgid "Click the 3 dots next to “Saved Passwords”."
msgstr "Click the 3 dots next to “Saved Passwords”."

msgid "Click the button below to open the CSV importer. Then drag the file into the marked area in the CSV importer."
msgstr "Click the button below to open the CSV importer. Then drag the file into the marked area in the CSV importer."

msgid "Click the heylogin icon in the toolbar and choose <0>“Always allow on every website…”</0>"
msgstr "Click the heylogin icon in the toolbar and choose <0>“Always allow on every website…”</0>"

msgid "Click the save icon."
msgstr "Click the save icon."

msgid "Click the three lines in the top right corner."
msgstr "Click the three lines in the top right corner."

msgid "Click your e-mail address"
msgstr "Click your e-mail address"

msgid "Close"
msgstr "Close"

msgid "Clothing sizes"
msgstr "Clothing sizes"

msgid "Configure Entra"
msgstr "Configure Entra"

msgid "Configure Microsoft Entra"
msgstr "Configure Microsoft Entra"

msgid "Configure your sync settings to sync users with Microsoft Entra"
msgstr "Configure your sync settings to sync users with Microsoft Entra"

msgid "Confirm"
msgstr "Confirm"

msgid "Confirm action"
msgstr "Confirm action"

msgid "Confirm code"
msgstr "Confirm code"

msgid "Confirm the first dialog with <0>“Always Allow…”</0>"
msgstr "Confirm the first dialog with <0>“Always Allow…”</0>"

msgid "Confirm the second dialog with <0>“Always allow on Every Website”</0>"
msgstr "Confirm the second dialog with <0>“Always allow on Every Website”</0>"

msgid "Confirm with security key (FIDO2), Touch ID or Windows Hello"
msgstr "Confirm with security key (FIDO2), Touch ID or Windows Hello"

msgid "Confirm with smartphone"
msgstr "Confirm with smartphone"

msgid "Connect"
msgstr "Connect"

msgid "Connect devices"
msgstr "Connect devices"

msgid "Connect login device"
msgstr "Connect login device"

msgid "Connect now"
msgstr "Connect now"

msgid "Connect security key"
msgstr "Connect security key"

msgid "Connect to Entra"
msgstr "Connect to Entra"

msgid "Connect users"
msgstr "Connect users"

msgid "Connect via PIN"
msgstr "Connect via PIN"

msgid "Connected"
msgstr "Connected"

msgid "Connected to Entra"
msgstr "Connected to Entra"

#. placeholder {0}: browserSupport.browserDescription
msgid "Connecting new devices using a security key is not supported by your browser ({0})."
msgstr "Connecting new devices using a security key is not supported by your browser ({0})."

msgid "Connecting new devices with a security key requires Windows 11 version 22H2 or newer. Please upgrade Windows to use this feature."
msgstr "Connecting new devices with a security key requires Windows 11 version 22H2 or newer. Please upgrade Windows to use this feature."

msgid "Connecting with security key failed."
msgstr "Connecting with security key failed."

msgid "Connecting…"
msgstr "Connecting…"

msgid "Connection failed!"
msgstr "Connection failed!"

msgid "Connection is being established…"
msgstr "Connection is being established…"

msgid "Connection successful!"
msgstr "Connection successful!"

msgid "Contact"
msgstr "Contact"

msgid "Contact profile picture"
msgstr "Contact profile picture"

msgid "Contact sales"
msgstr "Contact sales"

msgid "Contact support"
msgstr "Contact support"

msgid "Contact Support"
msgstr "Contact Support"

msgid "Contained empty custom field name"
msgstr "Contained empty custom field name"

msgid "Continue"
msgstr "Continue"

msgid "Continue plan"
msgstr "Continue plan"

msgid "Continue to configure"
msgstr "Continue to configure"

msgid "Continue to my logins"
msgstr "Continue to my logins"

msgid "Continue to review"
msgstr "Continue to review"

msgid "Continuous monitoring of <0>{localizedTotalPwnCountBillions} bn stolen accounts</0> on the web*"
msgstr "Continuous monitoring of <0>{localizedTotalPwnCountBillions} bn stolen accounts</0> on the web*"

msgid "Contract period:"
msgstr "Contract period:"

msgid "Contract period: <0>{formattedStartDate} to {formattedEndDate}</0>"
msgstr "Contract period: <0>{formattedStartDate} to {formattedEndDate}</0>"

msgid "Convert"
msgstr "Convert"

#. placeholder {0}: organization.name
msgid "Convert {0} to an independent organization"
msgstr "Convert {0} to an independent organization"

#. placeholder {0}: organization.name
msgid "Convert {0} to an independent organization?"
msgstr "Convert {0} to an independent organization?"

msgid "Convert to a managed organization?"
msgstr "Convert to a managed organization?"

msgid "Convert to independent organization"
msgstr "Convert to independent organization"

msgid "Convert to managed organization"
msgstr "Convert to managed organization"

#. placeholder {0}: singularCandidate.name
msgid "Convert to organization managed by {0}?"
msgstr "Convert to organization managed by {0}?"

msgctxt "KeeperImport"
msgid "Country"
msgstr "Country"

msgid "Coupon successfully redeemed."
msgstr "Coupon successfully redeemed."

msgid "Create"
msgstr "Create"

msgid "Create an organization or a private account to export your logins."
msgstr "Create an organization or a private account to export your logins."

msgid "Create an organization or a private account to import logins."
msgstr "Create an organization or a private account to import logins."

msgid "Create an organization or a private account to manage your logins."
msgstr "Create an organization or a private account to manage your logins."

msgid "Create encrypted link"
msgstr "Create encrypted link"

msgid "Create encrypted links to retrieve the login password via HTTP API. The link content is encrypted to the specified age recipient."
msgstr "Create encrypted links to retrieve the login password via HTTP API. The link content is encrypted to the specified age recipient."

msgid "Create login inbox"
msgstr "Create login inbox"

msgid "Create managed organizations"
msgstr "Create managed organizations"

msgid "Create new"
msgstr "Create new"

msgid "Create new account"
msgstr "Create new account"

msgid "Create new organization"
msgstr "Create new organization"

msgid "Create new role"
msgstr "Create new role"

msgid "Create organization"
msgstr "Create organization"

msgid "Create private account"
msgstr "Create private account"

msgid "Create teams"
msgstr "Create teams"

msgid "Create teams that automatically keep members consistent with an Entra group"
msgstr "Create teams that automatically keep members consistent with an Entra group"

msgid "Create your account"
msgstr "Create your account"

msgid "Create your heylogin account"
msgstr "Create your heylogin account"

msgid "Create your organization on <0>heylogin.app</0>"
msgstr "Create your organization on <0>heylogin.app</0>"

msgid "Created"
msgstr "Created"

msgid "Created at"
msgstr "Created at"

msgid "Created at {formattedCreationTime}."
msgstr "Created at {formattedCreationTime}."

msgid "Created at {formattedCreationTime}. Not opened yet."
msgstr "Created at {formattedCreationTime}. Not opened yet."

msgid "Created on"
msgstr "Created on"

msgid "Credential Exchange"
msgstr "Credential Exchange"

msgid "Credit card CVV"
msgstr "Credit card CVV"

msgid "Credit card expiration date"
msgstr "Credit card expiration date"

msgid "Credit card holder"
msgstr "Credit card holder"

msgid "Credit card number"
msgstr "Credit card number"

msgid "Credit card pin"
msgstr "Credit card pin"

msgid "Credit card security code"
msgstr "Credit card security code"

msgid "Credit cards"
msgstr "Credit cards"

msgid "Credit status information"
msgstr "Credit status information"

msgid "CSV"
msgstr "CSV"

msgid "CSV File"
msgstr "CSV File"

msgid "CSV file accepted"
msgstr "CSV file accepted"

msgid "Ctrl"
msgstr "Ctrl"

msgid "Current Plan"
msgstr "Current Plan"

msgid "Current version"
msgstr "Current version"

msgid "Currently there are no betas available."
msgstr "Currently there are no betas available."

msgid "Currently viewing recycle bin"
msgstr "Currently viewing recycle bin"

msgid "Currently viewing settings"
msgstr "Currently viewing settings"

msgid "Currently, no organizations are managed by {parentOrgName}"
msgstr "Currently, no organizations are managed by {parentOrgName}"

msgid "Custom"
msgstr "Custom"

msgid "Custom password policy"
msgstr "Custom password policy"

msgid "Custom roles (RBAC)"
msgstr "Custom roles (RBAC)"

msgid "Customer feedback"
msgstr "Customer feedback"

msgid "Customer Inc."
msgstr "Customer Inc."

msgid "Customer interactions"
msgstr "Customer interactions"

msgid "Dashlane"
msgstr "Dashlane"

msgid "Data provided by <0>haveibeenpwned.com</0>"
msgstr "Data provided by <0>haveibeenpwned.com</0>"

msgid "Date"
msgstr "Date"

msgctxt "KeeperImport"
msgid "Date"
msgstr "Date"

msgctxt "KeeperImport"
msgid "Date active"
msgstr "Date active"

msgctxt "KeeperImport"
msgid "Date issued"
msgstr "Date issued"

#. placeholder {0}: entry.formattedImportDate
msgid "Date: {0}"
msgstr "Date: {0}"

msgid "Dates of birth"
msgstr "Dates of birth"

msgid "Deceased date"
msgstr "Deceased date"

msgid "Deceased statuses"
msgstr "Deceased statuses"

msgid "Delegated admin"
msgstr "Delegated admin"

msgid "Delegated Admins"
msgstr "Delegated Admins"

msgid "Delegated admins cannot be disconnected."
msgstr "Delegated admins cannot be disconnected."

msgid "Delegated admins cannot be removed."
msgstr "Delegated admins cannot be removed."

msgid "Delegated admins may not have personal logins"
msgstr "Delegated admins may not have personal logins"

msgid "Delete"
msgstr "Delete"

msgid "Delete edit history"
msgstr "Delete edit history"

msgid "Delete edit history for all logins?"
msgstr "Delete edit history for all logins?"

msgid "Delete login inbox"
msgstr "Delete login inbox"

msgid "Delete organization"
msgstr "Delete organization"

#. placeholder {0}: organization.name
msgid "Delete organization – {0}"
msgstr "Delete organization – {0}"

msgid "Delete private account"
msgstr "Delete private account"

msgid "Delete private heylogin account?"
msgstr "Delete private heylogin account?"

msgid "Delete role"
msgstr "Delete role"

msgid "Delete team"
msgstr "Delete team"

msgid "Deleted by"
msgstr "Deleted by"

msgid "Deleted on"
msgstr "Deleted on"

msgid "Deleting…"
msgstr "Deleting…"

msgid "Deletion cancelled"
msgstr "Deletion cancelled"

msgid "Deletion requested by"
msgstr "Deletion requested by"

msgid "Delimiter not found"
msgstr "Delimiter not found"

msgid "Delivery instructions"
msgstr "Delivery instructions"

msgid "Demo License (NFR)"
msgstr "Demo License (NFR)"

msgid "Description"
msgstr "Description"

msgid "Deselect all"
msgstr "Deselect all"

msgid "Details"
msgstr "Details"

msgid "Device information"
msgstr "Device information"

msgid "Device is locked after <0/> without activity."
msgstr "Device is locked after <0/> without activity."

msgid "Device serial numbers"
msgstr "Device serial numbers"

msgid "Device usage tracking data"
msgstr "Device usage tracking data"

msgid "Devices are locked after at most <0/> without activity."
msgstr "Devices are locked after at most <0/> without activity."

msgid "Disable sync for accounts"
msgstr "Disable sync for accounts"

msgid "disabled on this device"
msgstr "disabled on this device"

msgid "Disconnect"
msgstr "Disconnect"

msgid "Disconnect security key"
msgstr "Disconnect security key"

msgid "Disconnect security key?"
msgstr "Disconnect security key?"

msgid "Disconnecting…"
msgstr "Disconnecting…"

msgid "Display name"
msgstr "Display name"

msgid "Displayed name"
msgstr "Displayed name"

msgid "Do you have additional questions? Please contact our <0>support team</0>"
msgstr "Do you have additional questions? Please contact our <0>support team</0>"

msgid "Do you like heylogin?"
msgstr "Do you like heylogin?"

msgid "Do you want to delete this organization and all its data?"
msgstr "Do you want to delete this organization and all its data?"

msgid "Don't enable Swipe to Login for all websites"
msgstr "Don't enable Swipe to Login for all websites"

msgid "Don’t forget to delete the ZIP file after the import!"
msgstr "Don’t forget to delete the ZIP file after the import!"

msgid "Done"
msgstr "Done"

msgid "Download"
msgstr "Download"

msgid "Download the <0>heylogin app</0>"
msgstr "Download the <0>heylogin app</0>"

msgid "Drag the CSV file into the marked area."
msgstr "Drag the CSV file into the marked area."

msgid "Drag the file into the marked area."
msgstr "Drag the file into the marked area."

msgid "Drag the ZIP file into the marked area below."
msgstr "Drag the ZIP file into the marked area below."

msgid "Drinking habits"
msgstr "Drinking habits"

msgctxt "KeeperImport"
msgid "Driver's license number"
msgstr "Driver's license number"

msgid "Driver's licenses"
msgstr "Driver's licenses"

msgid "Drug habits"
msgstr "Drug habits"

msgid "Duplicate"
msgstr "Duplicate"

msgid "E-mail"
msgstr "E-mail"

msgid "E-mail address"
msgstr "E-mail address"

msgid "E-mail or username"
msgstr "E-mail or username"

msgid "E-mail verification was successful"
msgstr "E-mail verification was successful"

msgid "Each link can only be used once. The password will be visible."
msgstr "Each link can only be used once. The password will be visible."

msgid "Eating habits"
msgstr "Eating habits"

msgid "Edge Extension (Beta)"
msgstr "Edge Extension (Beta)"

msgid "Edit"
msgstr "Edit"

msgid "Edit email"
msgstr "Edit email"

msgid "Edit history (last 30 days)"
msgstr "Edit history (last 30 days)"

msgid "Edit history added"
msgstr "Edit history added"

msgid "Edit history and trash"
msgstr "Edit history and trash"

msgid "Education levels"
msgstr "Education levels"

msgid "eight hours"
msgstr "eight hours"

msgid "Email"
msgstr "Email"

msgctxt "KeeperImport"
msgid "Email"
msgstr "Email"

msgid "Email addresses"
msgstr "Email addresses"

msgid "Email may not be empty!"
msgstr "Email may not be empty!"

msgid "Email messages"
msgstr "Email messages"

msgid "Employers"
msgstr "Employers"

msgid "Employment statuses"
msgstr "Employment statuses"

msgid "Empty"
msgstr "Empty"

msgid "Enable"
msgstr "Enable"

msgid "Enable account"
msgstr "Enable account"

msgid "Enable automatic disconnect"
msgstr "Enable automatic disconnect"

msgid "Enable automatic provisioning"
msgstr "Enable automatic provisioning"

msgid "Enable custom roles (RBAC)"
msgstr "Enable custom roles (RBAC)"

msgid "Enable Swipe to Login"
msgstr "Enable Swipe to Login"

msgid "Enabled on this device"
msgstr "Enabled on this device"

msgid "Encrypted keys"
msgstr "Encrypted keys"

msgid "Encrypted Links"
msgstr "Encrypted Links"

msgid "End-to-end encryption is enabled."
msgstr "End-to-end encryption is enabled."

msgid "Enpass"
msgstr "Enpass"

msgid "Ensure your admin access to {orgName}"
msgstr "Ensure your admin access to {orgName}"

msgid "Enter <0>company email</0>"
msgstr "Enter <0>company email</0>"

msgid "Enter <0>email</0> and <1>start code</1>"
msgstr "Enter <0>email</0> and <1>start code</1>"

msgid "Enter <0>start code</0>"
msgstr "Enter <0>start code</0>"

msgid "Enter age recipient to create a new encrypted link"
msgstr "Enter age recipient to create a new encrypted link"

msgid "Enter new label"
msgstr "Enter new label"

msgid "Enter the 4-digit code"
msgstr "Enter the 4-digit code"

msgid "Enter the code on your smartphone so we know it's you."
msgstr "Enter the code on your smartphone so we know it's you."

msgid "Enter your master password and save the file."
msgstr "Enter your master password and save the file."

msgid "Enter your master password."
msgstr "Enter your master password."

msgid "Enter your start code"
msgstr "Enter your start code"

msgid "Enterprise"
msgstr "Enterprise"

msgid "Entra"
msgstr "Entra"

msgid "Entra is connected"
msgstr "Entra is connected"

msgid "Entra users in selected groups will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> selected users."
msgstr "Entra users in selected groups will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> selected users."

msgid "Entra users in the tenant will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> users in the tenant."
msgstr "Entra users in the tenant will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> users in the tenant."

msgid "Entra users will be automatically disconnected in heylogin when disabled or deleted in Entra."
msgstr "Entra users will be automatically disconnected in heylogin when disabled or deleted in Entra."

msgid "Entra users will be listed in heylogin but no account will be created"
msgstr "Entra users will be listed in heylogin but no account will be created"

msgid "Entry"
msgstr "Entry"

msgid "Error connecting to Entra"
msgstr "Error connecting to Entra"

msgid "Error during upload, please try again later."
msgstr "Error during upload, please try again later."

msgid "Error parsing entry"
msgstr "Error parsing entry"

msgid "Ethnicities"
msgstr "Ethnicities"

msgid "Event type"
msgstr "Event type"

msgid "Event types"
msgstr "Event types"

msgctxt "Storybook"
msgid "Example Company"
msgstr "Example Company"

msgid "Example Inc."
msgstr "Example Inc."

msgid "example.com"
msgstr "example.com"

msgid "Excel"
msgstr "Excel"

msgid "Existing account will be linked to Entra"
msgstr "Existing account will be linked to Entra"

msgid "Existing account will be unlinked from Entra"
msgstr "Existing account will be unlinked from Entra"

msgctxt "KeeperImport"
msgid "Expiration"
msgstr "Expiration"

msgid "Expiration date"
msgstr "Expiration date"

msgid "Expired"
msgstr "Expired"

msgid "Expired at {formattedExpiryTime}. Has not been opened."
msgstr "Expired at {formattedExpiryTime}. Has not been opened."

msgid "Expires at {formattedExpiryTime}"
msgstr "Expires at {formattedExpiryTime}"

msgid "Export"
msgstr "Export"

msgid "Export – {vaultSelectionLabel}"
msgstr "Export – {vaultSelectionLabel}"

msgid "Export a CSV file from your currently used tool or create one by hand."
msgstr "Export a CSV file from your currently used tool or create one by hand."

msgid "Export from"
msgstr "Export from"

msgid "Export logins"
msgstr "Export logins"

msgid "Export via the <0>heylogin export</0>."
msgstr "Export via the <0>heylogin export</0>."

msgid "Export your logins in the <0>Sticky Password TXT</0> format following the <1>StickyPassword export guide</1>. This will give you a .txt file containing all exported data."
msgstr "Export your logins in the <0>Sticky Password TXT</0> format following the <1>StickyPassword export guide</1>. This will give you a .txt file containing all exported data."

msgid "Export your logins in the CSV format following the <0>Dashlane export guide</0>. This will give you a .zip file containing all exported data."
msgstr "Export your logins in the CSV format following the <0>Dashlane export guide</0>. This will give you a .zip file containing all exported data."

msgid "Export your logins in the JSON format following the <0>Keeper export guide</0>. This will give you a .json file containing all exported data."
msgstr "Export your logins in the JSON format following the <0>Keeper export guide</0>. This will give you a .json file containing all exported data."

msgctxt "KeeperImport"
msgid "Ext"
msgstr "Ext"

msgid "Extend by 14 days once-only"
msgstr "Extend by 14 days once-only"

msgid "Extend test phase"
msgstr "Extend test phase"

msgid "Extensions & Apps"
msgstr "Extensions & Apps"

msgid "External links"
msgstr "External links"

msgid "Failed to renew"
msgstr "Failed to renew"

msgid "Failed to revoke"
msgstr "Failed to revoke"

msgid "Failed to send"
msgstr "Failed to send"

msgid "Family members' names"
msgstr "Family members' names"

msgid "Family plans"
msgstr "Family plans"

msgid "Family structure"
msgstr "Family structure"

msgid "Features"
msgstr "Features"

msgid "Feedback on {feature}"
msgstr "Feedback on {feature}"

msgid "FIDO2 compatible"
msgstr "FIDO2 compatible"

msgid "Field copied"
msgstr "Field copied"

msgid "Field inserted"
msgstr "Field inserted"

msgid "Field shown"
msgstr "Field shown"

msgid "File accepted"
msgstr "File accepted"

msgid "File not recognized"
msgstr "File not recognized"

msgid "Filter by group"
msgstr "Filter by group"

msgid "Filter users"
msgstr "Filter users"

msgid "Filter users by group"
msgstr "Filter users by group"

msgid "Financial investments"
msgstr "Financial investments"

msgid "Financial transactions"
msgstr "Financial transactions"

msgid "Finish"
msgstr "Finish"

msgid "Finish installing heylogin for Safari"
msgstr "Finish installing heylogin for Safari"

msgid "Finish setup"
msgstr "Finish setup"

msgctxt "KeeperImport"
msgid "First name"
msgstr "First name"

msgid "Fitness levels"
msgstr "Fitness levels"

msgid "five hours"
msgstr "five hours"

msgid "Flights taken"
msgstr "Flights taken"

msgid "Folder"
msgstr "Folder"

msgid "Follow the <0>Export all passwords</0> steps in the <1>Apple Passwords export guide</1> to export your data as a CSV file."
msgstr "Follow the <0>Export all passwords</0> steps in the <1>Apple Passwords export guide</1> to export your data as a CSV file."

msgid "Follow the <0>LastPass export guide</0> to export your data in the CSV format."
msgstr "Follow the <0>LastPass export guide</0> to export your data in the CSV format."

msgid "For large companies that want to manage complex organizational structures efficiently."
msgstr "For large companies that want to manage complex organizational structures efficiently."

msgid "For private users who want to simplify their login process."
msgstr "For private users who want to simplify their login process."

msgid "For small and medium-sized enterprises that want to share logins easily within the team. ‍"
msgstr "For small and medium-sized enterprises that want to share logins easily within the team. ‍"

msgid "Free"
msgstr "Free"

msgctxt "export logins"
msgid "from"
msgstr "from"

msgid "from 1Password"
msgstr "from 1Password"

msgid "from a CSV file"
msgstr "from a CSV file"

msgid "from addons.mozilla.org"
msgstr "from addons.mozilla.org"

msgid "from Apple Passwords"
msgstr "from Apple Passwords"

msgid "from Bitwarden"
msgstr "from Bitwarden"

msgid "from Dashlane"
msgstr "from Dashlane"

msgid "from Enpass"
msgstr "from Enpass"

msgid "from Excel"
msgstr "from Excel"

msgid "from Google Chrome"
msgstr "from Google Chrome"

msgid "from heylogin"
msgstr "from heylogin"

msgid "from iCloud Keychain"
msgstr "from iCloud Keychain"

msgid "from KeePass"
msgstr "from KeePass"

msgid "from Keeper"
msgstr "from Keeper"

msgid "from LastPass"
msgstr "from LastPass"

msgid "from Microsoft Edge"
msgstr "from Microsoft Edge"

msgid "from Mozilla Firefox"
msgstr "from Mozilla Firefox"

msgid "from Nordpass"
msgstr "from Nordpass"

msgid "from Proton Pass"
msgstr "from Proton Pass"

msgid "from Safari"
msgstr "from Safari"

msgid "from StickyPassword"
msgstr "from StickyPassword"

msgid "from the Chrome Web Store"
msgstr "from the Chrome Web Store"

msgid "from the Mac App Store"
msgstr "from the Mac App Store"

msgid "from the Microsoft Store"
msgstr "from the Microsoft Store"

msgid "Functionality of heylogin may be impaired due to incorrect system clock on this device."
msgstr "Functionality of heylogin may be impaired due to incorrect system clock on this device."

msgid "Genders"
msgstr "Genders"

msgid "Generate"
msgstr "Generate"

msgid "Generate and save passwords"
msgstr "Generate and save passwords"

msgid "Generate new backup code"
msgstr "Generate new backup code"

msgid "Geographic locations"
msgstr "Geographic locations"

msgid "Get an overview of apps/platforms used in your organization. Note: In this beta, only information from teams you have direct access to is displayed."
msgstr "Get an overview of apps/platforms used in your organization. Note: In this beta, only information from teams you have direct access to is displayed."

msgid "Get it in Edge"
msgstr "Get it in Edge"

msgid "Get it in Safari"
msgstr "Get it in Safari"

msgid "Give feedback"
msgstr "Give feedback"

msgid "Give us feedback on <0>{feature}</0>"
msgstr "Give us feedback on <0>{feature}</0>"

msgid "Go to <0>Managed organizations</0> to remove delegated admins."
msgstr "Go to <0>Managed organizations</0> to remove delegated admins."

msgid "Go to <0>Management</0> to add or remove organization users."
msgstr "Go to <0>Management</0> to add or remove organization users."

msgid "Go to imported logins"
msgstr "Go to imported logins"

msgid "Go to login"
msgstr "Go to login"

msgid "Go to login location"
msgstr "Go to login location"

msgid "Go to start page"
msgstr "Go to start page"

msgid "Google Chrome"
msgstr "Google Chrome"

msgid "Google Workspace"
msgstr "Google Workspace"

msgid "Got any questions? Contact us: <0>support@heylogin.com</0>"
msgstr "Got any questions? Contact us: <0>support@heylogin.com</0>"

msgid "Government issued IDs"
msgstr "Government issued IDs"

msgid "Group"
msgstr "Group"

msgid "Group (Entra)"
msgstr "Group (Entra)"

msgid "Group was created as a team"
msgstr "Group was created as a team"

msgid "Groups"
msgstr "Groups"

msgid "Groups (Entra)"
msgstr "Groups (Entra)"

msgid "Guest members are only members of this team, not of its organization. Guest members are deprecated, please add organization members instead."
msgstr "Guest members are only members of this team, not of its organization. Guest members are deprecated, please add organization members instead."

msgid "Guide for:"
msgstr "Guide for:"

msgid "Have a look at some upcoming features in heylogin! Test and help shape features early, before they are released to all users."
msgstr "Have a look at some upcoming features in heylogin! Test and help shape features early, before they are released to all users."

msgid "Health insurance information"
msgstr "Health insurance information"

msgid "Help Center"
msgstr "Help Center"

msgid "Hey, you made it!"
msgstr "Hey, you made it!"

msgid "heylogin"
msgstr "heylogin"

msgid "heylogin Business"
msgstr "heylogin Business"

msgid "heylogin can only be used with physical security keys (e.g. YubiKey)."
msgstr "heylogin can only be used with physical security keys (e.g. YubiKey)."

msgid "heylogin default password policy"
msgstr "heylogin default password policy"

msgid "heylogin Enterprise (Managed)"
msgstr "heylogin Enterprise (Managed)"

msgid "heylogin Enterprise MSP"
msgstr "heylogin Enterprise MSP"

msgid "heylogin works best with <0>Chrome, Edge, Firefox or Safari</0>"
msgstr "heylogin works best with <0>Chrome, Edge, Firefox or Safari</0>"

msgid "heylogin works best with <0>Chrome, Edge, or Firefox</0>"
msgstr "heylogin works best with <0>Chrome, Edge, or Firefox</0>"

msgid "heylogin works best with Chrome, Edge, Firefox or Safari"
msgstr "heylogin works best with Chrome, Edge, Firefox or Safari"

msgid "heylogin.me"
msgstr "heylogin.me"

msgid "Hide details"
msgstr "Hide details"

msgid "Hide instructions"
msgstr "Hide instructions"

msgid "Hide password"
msgstr "Hide password"

msgid "Hide passwords for read-only members"
msgstr "Hide passwords for read-only members"

msgid "Hint: Write down your backup code and keep it in a safe place."
msgstr "Hint: Write down your backup code and keep it in a safe place."

msgid "Historical passwords"
msgstr "Historical passwords"

msgid "HIV statuses"
msgstr "HIV statuses"

msgid "Home ownership statuses"
msgstr "Home ownership statuses"

msgid "Homepage URLs"
msgstr "Homepage URLs"

msgctxt "KeeperImport"
msgid "Host"
msgstr "Host"

msgctxt "KeeperImport"
msgid "Host name"
msgstr "Host name"

msgid "How did you hear about us?"
msgstr "How did you hear about us?"

msgid "How to update?"
msgstr "How to update?"

msgid "How to use Autotype"
msgstr "How to use Autotype"

msgid "https://browsehappy.com/?locale=en"
msgstr "https://browsehappy.com/?locale=en"

msgid "https://help.heylogin.com/en"
msgstr "https://help.heylogin.com/en"

#. help center link: on-premise backup
#. help center link: on-premises backup
msgid "https://help.heylogin.com/en/13f8872c7eda8013a6f2fcb7cacceccd"
msgstr "https://help.heylogin.com/en/13f8872c7eda8013a6f2fcb7cacceccd"

#. help center link: secrets api
msgid "https://help.heylogin.com/en/1628872c7eda8085bf0fd79d13b9967b"
msgstr "https://help.heylogin.com/en/1628872c7eda8085bf0fd79d13b9967b"

#. help center link: update firefox extension
msgid "https://help.heylogin.com/en/2868872c7eda8012b418fd4a5b2f8fc1"
msgstr "https://help.heylogin.com/en/2868872c7eda8012b418fd4a5b2f8fc1"

msgid "https://help.heylogin.com/en/3c18872c7eda80b2aaf5fc20ace4ce71"
msgstr "https://help.heylogin.com/en/3c18872c7eda80b2aaf5fc20ace4ce71"

#. help center link: hidden passwords
msgid "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"
msgstr "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"

#. help center link: browser support for additional devices
msgid "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#21afa0f6639944b893bd47e9565be0b3"
msgstr "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#21afa0f6639944b893bd47e9565be0b3"

#. help center link: receive passwords from external
msgid "https://help.heylogin.com/en/fb57286bc7f44190b95d16bb9fc2ae17"
msgstr "https://help.heylogin.com/en/fb57286bc7f44190b95d16bb9fc2ae17"

msgid "https://support.apple.com/en-euro/guide/passwords/mchl35b12625/mac#mchlafe418fe"
msgstr "https://support.apple.com/en-euro/guide/passwords/mchl35b12625/mac#mchlafe418fe"

msgid "https://support.apple.com/en-us/HT204416"
msgstr "https://support.apple.com/en-us/HT204416"

msgid "https://www.heylogin.com/en/contact-sales"
msgstr "https://www.heylogin.com/en/contact-sales"

msgid "https://www.heylogin.com/en/contact-support"
msgstr "https://www.heylogin.com/en/contact-support"

msgid "https://www.heylogin.com/en/enterprise"
msgstr "https://www.heylogin.com/en/enterprise"

msgid "https://www.heylogin.com/en/enterprise/"
msgstr "https://www.heylogin.com/en/enterprise/"

msgid "https://www.heylogin.com/en/privacy"
msgstr "https://www.heylogin.com/en/privacy"

msgid "https://www.heylogin.com/en/terms-of-use"
msgstr "https://www.heylogin.com/en/terms-of-use"

msgid "I am not {username}"
msgstr "I am not {username}"

msgid "I can't scan the QR code"
msgstr "I can't scan the QR code"

msgid "IBAN"
msgstr "IBAN"

msgid "iCloud Keychain"
msgstr "iCloud Keychain"

msgctxt "KeeperImport"
msgid "Identity number"
msgstr "Identity number"

msgid "If someone gave you a link to this page, please ask them to check it and send it again."
msgstr "If someone gave you a link to this page, please ask them to check it and send it again."

msgid "If the deletion was not triggered by you or triggered by accident, please contact our <0>support team</0>"
msgstr "If the deletion was not triggered by you or triggered by accident, please contact our <0>support team</0>"

msgid "If this problem persists, please <0>contact support</0>."
msgstr "If this problem persists, please <0>contact support</0>."

msgid "If you have any problems, consult the <0>Excel documentation on CSV export</0> or contact <1>heylogin support</1>"
msgstr "If you have any problems, consult the <0>Excel documentation on CSV export</0> or contact <1>heylogin support</1>"

msgid "If you have any problems, please consult the <0>Bitwarden export guide</0> or contact <1>heylogin support</1>"
msgstr "If you have any problems, please consult the <0>Bitwarden export guide</0> or contact <1>heylogin support</1>"

msgid "If you have any problems, please consult the <0>Firefox export guide</0> or contact <1>heylogin support</1>"
msgstr "If you have any problems, please consult the <0>Firefox export guide</0> or contact <1>heylogin support</1>"

msgid "If you have any problems, please consult the <0>Nordpass export guide</0> or contact <1>heylogin support</1>"
msgstr "If you have any problems, please consult the <0>Nordpass export guide</0> or contact <1>heylogin support</1>"

msgid "If you have any problems, please contact <0>heylogin support</0>"
msgstr "If you have any problems, please contact <0>heylogin support</0>"

msgid "If you lost access to your secure device, you can use the backup code to add a new device"
msgstr "If you lost access to your secure device, you can use the backup code to add a new device"

msgid "Image accepted"
msgstr "Image accepted"

msgid "Image is not valid"
msgstr "Image is not valid"

msgid "Image must be no larger than 500×500 pixels"
msgstr "Image must be no larger than 500×500 pixels"

msgid "Image must be square"
msgstr "Image must be square"

msgid "IMEI numbers"
msgstr "IMEI numbers"

msgid "Immediate threat analysis: Targeted measures for at-risk employee accounts."
msgstr "Immediate threat analysis: Targeted measures for at-risk employee accounts."

msgid "Immediately detect at-risk employee accounts"
msgstr "Immediately detect at-risk employee accounts"

msgid "Import"
msgstr "Import"

msgctxt "verb"
msgid "Import"
msgstr "Import"

msgid "Import details"
msgstr "Import details"

msgid "Import from browser"
msgstr "Import from browser"

msgid "Import from Chrome"
msgstr "Import from Chrome"

msgid "Import from Edge"
msgstr "Import from Edge"

msgid "Import from Firefox"
msgstr "Import from Firefox"

msgid "Import from password manager"
msgstr "Import from password manager"

msgid "Import from Safari"
msgstr "Import from Safari"

msgid "Import history"
msgstr "Import history"

msgid "Import into"
msgstr "Import into"

msgid "Import logins"
msgstr "Import logins"

msgid "import now"
msgstr "import now"

msgid "Import your employees from a CSV file"
msgstr "Import your employees from a CSV file"

msgid "Import your logins"
msgstr "Import your logins"

msgid "Important final step"
msgstr "Important final step"

msgid "Imported"
msgstr "Imported"

msgid "Importer"
msgstr "Importer"

msgid "Importer:"
msgstr "Importer:"

msgid "IMSI numbers"
msgstr "IMSI numbers"

msgid "In Excel go to “File” > “Save As” and click “Browse”."
msgstr "In Excel go to “File” > “Save As” and click “Browse”."

msgid "In organization"
msgstr "In organization"

msgid "In the “Save As” dialog box, under “Save as type”, choose “CSV (Comma delimited)”."
msgstr "In the “Save As” dialog box, under “Save as type”, choose “CSV (Comma delimited)”."

msgid "In the dialog that opens, click <0>“Always allow on every website”</0> again to confirm access."
msgstr "In the dialog that opens, click <0>“Always allow on every website”</0> again to confirm access."

msgid "inactive"
msgstr "inactive"

msgid "Inactive"
msgstr "Inactive"

msgid "Inactive (30+ days)"
msgstr "Inactive (30+ days)"

msgid "Included:"
msgstr "Included:"

msgid "including"
msgstr "including"

msgid "Income levels"
msgstr "Income levels"

msgid "Incorrect password and/or key file"
msgstr "Incorrect password and/or key file"

msgid "Individual permissions for each user"
msgstr "Individual permissions for each user"

msgid "Initial entry"
msgstr "Initial entry"

msgid "Innovatech Solutions"
msgstr "Innovatech Solutions"

msgid "Install"
msgstr "Install"

msgid "Install browser extension"
msgstr "Install browser extension"

msgid "Install Firefox"
msgstr "Install Firefox"

msgid "Install heylogin"
msgstr "Install heylogin"

msgid "install now"
msgstr "install now"

msgid "Install our beta extensions and apps to be the first to test unreleased features."
msgstr "Install our beta extensions and apps to be the first to test unreleased features."

msgid "Instant messenger identities"
msgstr "Instant messenger identities"

msgctxt "KeeperImport"
msgid "Insured's first name"
msgstr "Insured's first name"

msgctxt "KeeperImport"
msgid "Insured's last name"
msgstr "Insured's last name"

msgctxt "KeeperImport"
msgid "Insured's middle name"
msgstr "Insured's middle name"

msgid "Integrations"
msgstr "Integrations"

msgid "Integrations: Entra ID, Google Workspace, CSV import"
msgstr "Integrations: Entra ID, Google Workspace, CSV import"

msgid "Invalid"
msgstr "Invalid"

msgid "Invalid coupon code"
msgstr "Invalid coupon code"

msgid "Invalid domain"
msgstr "Invalid domain"

msgid "Invalid email"
msgstr "Invalid email"

msgid "Invalid link"
msgstr "Invalid link"

msgid "Invalid quotes"
msgstr "Invalid quotes"

msgid "Invalid start code"
msgstr "Invalid start code"

msgid "Invite expired"
msgstr "Invite expired"

msgid "Invited"
msgstr "Invited"

msgid "Invoice"
msgstr "Invoice"

msgid "Invoices"
msgstr "Invoices"

msgid "iOS App (Testflight Beta)"
msgstr "iOS App (Testflight Beta)"

msgid "IP address"
msgstr "IP address"

msgid "IP addresses"
msgstr "IP addresses"

msgid "Issuing bank"
msgstr "Issuing bank"

msgid "Job applications"
msgstr "Job applications"

msgid "Job titles"
msgstr "Job titles"

msgid "Join"
msgstr "Join"

msgid "Join organization"
msgstr "Join organization"

msgid "Joined at: {formattedJoinDate}"
msgstr "Joined at: {formattedJoinDate}"

msgid "Joining failed. Please reload the page to make sure you use the latest version of heylogin and try again."
msgstr "Joining failed. Please reload the page to make sure you use the latest version of heylogin and try again."

msgid "KeePass"
msgstr "KeePass"

msgid "Keeper"
msgstr "Keeper"

msgid "Key file (optional)"
msgstr "Key file (optional)"

msgctxt "KeeperImport"
msgid "Key pair"
msgstr "Key pair"

msgid "Keyboard shortcut:"
msgstr "Keyboard shortcut:"

msgid "Known since:"
msgstr "Known since:"

msgid "Label may not be empty"
msgstr "Label may not be empty"

msgid "Labels"
msgstr "Labels"

msgid "last"
msgstr "last"

msgid "Last 30 days"
msgstr "Last 30 days"

msgid "Last 7 days"
msgstr "Last 7 days"

msgid "Last 90 days"
msgstr "Last 90 days"

msgid "Last active {formattedLastActiveDate}"
msgstr "Last active {formattedLastActiveDate}"

msgid "Last change"
msgstr "Last change"

msgctxt "KeeperImport"
msgid "Last name"
msgstr "Last name"

msgid "LastPass"
msgstr "LastPass"

msgid "Latest data added:"
msgstr "Latest data added:"

msgid "lea@example.com"
msgstr "lea@example.com"

msgid "Leak check result"
msgstr "Leak check result"

msgid "Leak check: not ok"
msgstr "Leak check: not ok"

msgid "Leak check: not performed"
msgstr "Leak check: not performed"

msgid "Leak check: ok"
msgstr "Leak check: ok"

msgid "Leaked passwords"
msgstr "Leaked passwords"

msgid "Learn more"
msgstr "Learn more"

msgid "Learn more about heylogin"
msgstr "Learn more about heylogin"

msgid "Leave"
msgstr "Leave"

msgid "Leave “{profileLabel}”?"
msgstr "Leave “{profileLabel}”?"

msgid "Leave beta"
msgstr "Leave beta"

msgid "Leave organization"
msgstr "Leave organization"

msgid "Leave team"
msgstr "Leave team"

msgid "Leaving…"
msgstr "Leaving…"

msgid "Length"
msgstr "Length"

msgctxt "KeeperImport"
msgid "License number"
msgstr "License number"

msgid "License plates"
msgstr "License plates"

msgid "Limit time for automatic device lock after user inactivity"
msgstr "Limit time for automatic device lock after user inactivity"

msgid "linda@example.com"
msgstr "linda@example.com"

msgid "Link your employees directly from Google Workspace"
msgstr "Link your employees directly from Google Workspace"

msgid "Link your employees directly from Microsoft Entra"
msgstr "Link your employees directly from Microsoft Entra"

msgid "Links expired in the last 7 days"
msgstr "Links expired in the last 7 days"

msgid "Links used in the last 7 days"
msgstr "Links used in the last 7 days"

msgid "List personal logins of other users"
msgstr "List personal logins of other users"

msgid "List users from your Entra tenant in heylogin"
msgstr "List users from your Entra tenant in heylogin"

msgid "Living costs"
msgstr "Living costs"

msgid "Load more"
msgstr "Load more"

msgid "Loading"
msgstr "Loading"

msgid "Loading data"
msgstr "Loading data"

msgid "Loading data…"
msgstr "Loading data…"

msgid "Loading…"
msgstr "Loading…"

msgid "Loan information"
msgstr "Loan information"

msgid "Location"
msgstr "Location"

msgid "Log in as another user"
msgstr "Log in as another user"

msgid "log in in your browser"
msgstr "log in in your browser"

msgid "Log in now"
msgstr "Log in now"

msgid "Log in on <0>app.nordpass.com</0>"
msgstr "Log in on <0>app.nordpass.com</0>"

msgid "Log in once into a website with username and password."
msgstr "Log in once into a website with username and password."

msgid "Log out"
msgstr "Log out"

msgid "Log out this user"
msgstr "Log out this user"

msgid "Login"
msgstr "Login"

msgid "Login created"
msgstr "Login created"

msgid "Login deleted"
msgstr "Login deleted"

msgid "Login denied"
msgstr "Login denied"

msgid "Login device connected"
msgstr "Login device connected"

msgid "Login devices"
msgstr "Login devices"

msgid "Login Devices"
msgstr "Login Devices"

msgid "Login edited"
msgstr "Login edited"

msgid "Login histories"
msgstr "Login histories"

msgid "Login inbox"
msgstr "Login inbox"

msgid "Login Inbox"
msgstr "Login Inbox"

msgid "Login inbox enabled"
msgstr "Login inbox enabled"

msgid "Login information"
msgstr "Login information"

msgid "Login location"
msgstr "Login location"

msgid "Login locations"
msgstr "Login locations"

msgid "Login moved"
msgstr "Login moved"

msgid "Login moved to recycle bin"
msgstr "Login moved to recycle bin"

msgid "Login recipient"
msgstr "Login recipient"

msgid "Login restored from recycle bin"
msgstr "Login restored from recycle bin"

msgid "Login scopes"
msgstr "Login scopes"

msgid "Login sender"
msgstr "Login sender"

msgid "Login successful"
msgstr "Login successful"

msgid "Logins"
msgstr "Logins"

msgid "Logins are shared to the personal logins of the recipient."
msgstr "Logins are shared to the personal logins of the recipient."

#. placeholder {0}: skippedVaults[0].label
msgid "Logins from “{0}” will be skipped during export because you are not allowed to see passwords."
msgstr "Logins from “{0}” will be skipped during export because you are not allowed to see passwords."

msgid "Logins from these locations will be skipped during export because you are not allowed to see passwords:"
msgstr "Logins from these locations will be skipped during export because you are not allowed to see passwords:"

msgid "Logins in all organization teams as well as all accessible logins"
msgstr "Logins in all organization teams as well as all accessible logins"

msgid "Loyalty program details"
msgstr "Loyalty program details"

msgid "MAC addresses"
msgstr "MAC addresses"

msgid "Malformed TOTP secret"
msgstr "Malformed TOTP secret"

msgid "Manage all managed organizations"
msgstr "Manage all managed organizations"

msgid "Manage plan"
msgstr "Manage plan"

msgid "Manage users"
msgstr "Manage users"

msgid "Managed organizations"
msgstr "Managed organizations"

msgid "Managed Organizations"
msgstr "Managed Organizations"

msgid "Management"
msgstr "Management"

msgctxt "Storybook"
msgid "marie@example.com"
msgstr "marie@example.com"

msgid "Marital statuses"
msgstr "Marital statuses"

msgid "Maximize"
msgstr "Maximize"

msgid "Members of the managing organization that access this organization get this role. It cannot be manually assigned."
msgstr "Members of the managing organization that access this organization get this role. It cannot be manually assigned."

msgid "Message"
msgstr "Message"

msgid "Message (optional)"
msgstr "Message (optional)"

msgid "Message may not be empty!"
msgstr "Message may not be empty!"

msgid "Microsoft Edge"
msgstr "Microsoft Edge"

msgid "Microsoft Entra"
msgstr "Microsoft Entra"

msgctxt "KeeperImport"
msgid "Middle name"
msgstr "Middle name"

msgid "Military service"
msgstr "Military service"

msgid "Minimize"
msgstr "Minimize"

msgid "Missing age recipient"
msgstr "Missing age recipient"

msgid "Missing quotes"
msgstr "Missing quotes"

msgid "Mnemonic phrases"
msgstr "Mnemonic phrases"

msgid "Monitored Domains"
msgstr "Monitored Domains"

msgid "Monitoring"
msgstr "Monitoring"

msgid "Monthly"
msgstr "Monthly"

msgid "More options"
msgstr "More options"

msgid "More security – access only for those who really need it (the principle of least privilege)"
msgstr "More security – access only for those who really need it (the principle of least privilege)"

msgid "More transparency for your logins"
msgstr "More transparency for your logins"

msgid "Mothers' maiden names"
msgstr "Mothers' maiden names"

msgid "Move"
msgstr "Move"

msgid "Move logins from team “{truncatedName}” to “{moveOnDeleteTargetName}”."
msgstr "Move logins from team “{truncatedName}” to “{moveOnDeleteTargetName}”."

msgid "Move logins from the login inbox to “{moveOnDeleteTargetName}”."
msgstr "Move logins from the login inbox to “{moveOnDeleteTargetName}”."

msgid "Move logins to"
msgstr "Move logins to"

msgid "Mozilla Firefox"
msgstr "Mozilla Firefox"

msgctxt "KeeperImport"
msgid "Multiline"
msgstr "Multiline"

msgid "Multiple roles"
msgstr "Multiple roles"

msgid "Must be a square image no larger than 500×500 pixels"
msgstr "Must be a square image no larger than 500×500 pixels"

msgid "Must contain a digit"
msgstr "Must contain a digit"

msgid "Must contain a lower case letter"
msgstr "Must contain a lower case letter"

msgid "Must contain a special character"
msgstr "Must contain a special character"

msgid "Must contain an upper case letter"
msgstr "Must contain an upper case letter"

msgid "My Logins"
msgstr "My Logins"

msgid "Name"
msgstr "Name"

msgctxt "KeeperImport"
msgid "Name"
msgstr "Name"

msgid "Name may not be empty!"
msgstr "Name may not be empty!"

msgid "Names"
msgstr "Names"

msgid "Nationalities"
msgstr "Nationalities"

msgid "Navigate to the Proton Pass settings page."
msgstr "Navigate to the Proton Pass settings page."

msgid "Net worths"
msgstr "Net worths"

msgid "New accounts / invites"
msgstr "New accounts / invites"

msgid "New accounts will be created"
msgstr "New accounts will be created"

msgid "New beta feature"
msgstr "New beta feature"

msgid "New email address"
msgstr "New email address"

msgid "New entry"
msgstr "New entry"

msgid "New feature"
msgstr "New feature"

msgid "New label"
msgstr "New label"

msgid "New Organization"
msgstr "New Organization"

msgid "New organization created."
msgstr "New organization created."

msgid "New role created."
msgstr "New role created."

msgid "New Support Request"
msgstr "New Support Request"

msgid "New Team"
msgstr "New Team"

msgid "New team created."
msgstr "New team created."

msgid "Newly joined"
msgstr "Newly joined"

msgid "next"
msgstr "next"

msgid "Next"
msgstr "Next"

msgid "Next billing at"
msgstr "Next billing at"

msgid "Nicknames"
msgstr "Nicknames"

msgid "No access?"
msgstr "No access?"

msgid "No accessible organizations match this filter"
msgstr "No accessible organizations match this filter"

msgid "No account"
msgstr "No account"

msgid "No activity for more than {INACTIVITY_THRESHOLD_DAYS} days"
msgstr "No activity for more than {INACTIVITY_THRESHOLD_DAYS} days"

msgid "No change"
msgstr "No change"

msgid "No changes to synced users."
msgstr "No changes to synced users."

msgid "No connection to <0>{integrationName}</0> could be established. Please try again or contact <1>support</1>."
msgstr "No connection to <0>{integrationName}</0> could be established. Please try again or contact <1>support</1>."

msgid "No deleted entries found"
msgstr "No deleted entries found"

msgid "No events matching this filter"
msgstr "No events matching this filter"

msgid "No export source found"
msgstr "No export source found"

msgid "No groups found"
msgstr "No groups found"

msgid "No groups synchronized"
msgstr "No groups synchronized"

msgid "No import target found"
msgstr "No import target found"

msgid "No keyboard shortcut set."
msgstr "No keyboard shortcut set."

msgid "No login inbox found"
msgstr "No login inbox found"

msgid "no logins"
msgstr "no logins"

msgid "No logins found"
msgstr "No logins found"

msgid "No matching options"
msgstr "No matching options"

msgid "No member"
msgstr "No member"

msgid "No move target found"
msgstr "No move target found"

msgid "No organization exists for this email address. Please contact your admin, or use the heylogin app to register a new organization or private account."
msgstr "No organization exists for this email address. Please contact your admin, or use the heylogin app to register a new organization or private account."

msgid "No organizations match this filter"
msgstr "No organizations match this filter"

msgid "No permission"
msgstr "No permission"

msgid "No permission for this page"
msgstr "No permission for this page"

msgid "No role"
msgstr "No role"

msgid "No target found"
msgstr "No target found"

msgid "No user found"
msgstr "No user found"

msgid "Non-admins may export {exportSettingsSelect} from this organization."
msgstr "Non-admins may export {exportSettingsSelect} from this organization."

msgid "None"
msgstr "None"

msgid "Nordpass"
msgstr "Nordpass"

msgid "Not a login"
msgstr "Not a login"

msgid "Not available on this device"
msgstr "Not available on this device"

msgid "Not connected"
msgstr "Not connected"

msgid "Not ok"
msgstr "Not ok"

msgid "Not performed"
msgstr "Not performed"

msgid "Not policy compliant"
msgstr "Not policy compliant"

msgid "Not supported"
msgstr "Not supported"

msgid "Not supported on this device"
msgstr "Not supported on this device"

msgid "Note"
msgstr "Note"

msgctxt "KeeperImport"
msgid "Note"
msgstr "Note"

msgid "Note: This integration must be set up by an Entra user with privileges to list users and groups in your tenant."
msgstr "Note: This integration must be set up by an Entra user with privileges to list users and groups in your tenant."

msgid "Notification when leaked accounts are found on the web"
msgstr "Notification when leaked accounts are found on the web"

msgctxt "KeeperImport"
msgid "Number"
msgstr "Number"

msgid "Number of additional licenses"
msgstr "Number of additional licenses"

msgid "Number of licenses"
msgstr "Number of licenses"

msgid "Number of licenses must be a number"
msgstr "Number of licenses must be a number"

#. placeholder {0}: organization.userCount
msgid "Number of licenses must be at least {0}"
msgstr "Number of licenses must be at least {0}"

msgid "Number of licenses must be greater than zero"
msgstr "Number of licenses must be greater than zero"

#. placeholder {0}: license.licenseCount
msgid "Number of licenses: <0>{0}</0>"
msgstr "Number of licenses: <0>{0}</0>"

msgid "Number of users"
msgstr "Number of users"

msgid "Occupations"
msgstr "Occupations"

msgid "Ok"
msgstr "Ok"

msgid "OK"
msgstr "OK"

msgid "Okay"
msgstr "Okay"

msgid "Okay, got it"
msgstr "Okay, got it"

msgid "On all stored webpages"
msgstr "On all stored webpages"

msgid "On request"
msgstr "On request"

msgid "on your laptop or PC for all websites"
msgstr "on your laptop or PC for all websites"

msgid "On-premises backup (optional)"
msgstr "On-premises backup (optional)"

msgid "Onboarding support (optional)"
msgstr "Onboarding support (optional)"

msgid "Only {recipientName} can read this login."
msgstr "Only {recipientName} can read this login."

msgid "Only organization admins may create teams"
msgstr "Only organization admins may create teams"

msgid "Only users from selected groups will be loaded from Entra."
msgstr "Only users from selected groups will be loaded from Entra."

msgid "Open"
msgstr "Open"

#. placeholder {0}: personalLoginsInfo.email
msgid "Open {0}'s logins"
msgstr "Open {0}'s logins"

msgid "Open <0>{securityKeyUri}</0> in a desktop browser"
msgstr "Open <0>{securityKeyUri}</0> in a desktop browser"

msgid "Open CSV Importer"
msgstr "Open CSV Importer"

msgid "Open heylogin.app"
msgstr "Open heylogin.app"

msgid "Open login inbox"
msgstr "Open login inbox"

msgid "Open management"
msgstr "Open management"

#. placeholder {0}: organization.name
msgid "Open organization {0}"
msgstr "Open organization {0}"

msgid "Open settings"
msgstr "Open settings"

msgid "Open update instructions"
msgstr "Open update instructions"

msgid "Opened at {formattedOpenTime}"
msgstr "Opened at {formattedOpenTime}"

msgid "Opera"
msgstr "Opera"

msgid "Order Number"
msgstr "Order Number"

msgid "Organization already deleted"
msgstr "Organization already deleted"

msgid "Organization deleted"
msgstr "Organization deleted"

msgid "Organization domain (optional)"
msgstr "Organization domain (optional)"

msgid "Organization name"
msgstr "Organization name"

msgid "Organization name may not be empty!"
msgstr "Organization name may not be empty!"

msgid "Organization role"
msgstr "Organization role"

msgid "Organization settings"
msgstr "Organization settings"

msgid "Organization:"
msgstr "Organization:"

msgid "Origin"
msgstr "Origin"

msgid "Origins"
msgstr "Origins"

msgctxt "KeeperImport"
msgid "Other type"
msgstr "Other type"

msgid "Page not found"
msgstr "Page not found"

msgid "Parenting plans"
msgstr "Parenting plans"

msgid "Partial credit card data"
msgstr "Partial credit card data"

msgid "Partial dates of birth"
msgstr "Partial dates of birth"

msgid "Partial phone numbers"
msgstr "Partial phone numbers"

msgid "Passkey"
msgstr "Passkey"

msgid "Passkeys"
msgstr "Passkeys"

msgctxt "KeeperImport"
msgid "Passport number"
msgstr "Passport number"

msgid "Passport numbers"
msgstr "Passport numbers"

msgid "Password"
msgstr "Password"

msgid "Password copied"
msgstr "Password copied"

msgid "Password hints"
msgstr "Password hints"

msgid "Password inserted"
msgstr "Password inserted"

msgid "Password is empty"
msgstr "Password is empty"

msgid "Password is not compliant with the password policy."
msgstr "Password is not compliant with the password policy."

msgid "Password is PIN"
msgstr "Password is PIN"

msgid "Password policy"
msgstr "Password policy"

msgid "Password policy active"
msgstr "Password policy active"

msgid "Password policy check result"
msgstr "Password policy check result"

msgid "Password policy: check not performed"
msgstr "Password policy: check not performed"

msgid "Password policy: not ok"
msgstr "Password policy: not ok"

msgid "Password policy: ok"
msgstr "Password policy: ok"

msgid "Password security unknown"
msgstr "Password security unknown"

msgid "Password shown"
msgstr "Password shown"

msgid "Password strength"
msgstr "Password strength"

msgid "Password strengths"
msgstr "Password strengths"

msgid "Password was found in a list of leaked passwords."
msgstr "Password was found in a list of leaked passwords."

msgid "Passwords"
msgstr "Passwords"

msgid "Passwords cannot be viewed"
msgstr "Passwords cannot be viewed"

msgid "paul@example.com"
msgstr "paul@example.com"

msgid "Paused"
msgstr "Paused"

#. placeholder {0}: format(new Date(subscriptionStatus.pausedAt), 'P', { locale: getDateFnsLocale(), })
msgid "Paused at {0}"
msgstr "Paused at {0}"

msgid "Payment"
msgstr "Payment"

msgctxt "KeeperImport"
msgid "Payment card"
msgstr "Payment card"

msgid "Payment histories"
msgstr "Payment histories"

msgid "Payment methods"
msgstr "Payment methods"

msgid "Payment overdue"
msgstr "Payment overdue"

msgid "Payment pending"
msgstr "Payment pending"

msgid "Perhaps you clicked on an old link, or opened an outdated bookmark?"
msgstr "Perhaps you clicked on an old link, or opened an outdated bookmark?"

msgid "Permanently delete"
msgstr "Permanently delete"

msgid "Permissions"
msgstr "Permissions"

msgid "Permissions for this user are set automatically"
msgstr "Permissions for this user are set automatically"

msgid "Personal descriptions"
msgstr "Personal descriptions"

msgid "Personal health data"
msgstr "Personal health data"

msgid "Personal interests"
msgstr "Personal interests"

msgid "Personal login"
msgstr "Personal login"

msgid "Personal logins"
msgstr "Personal logins"

msgid "Personal Logins"
msgstr "Personal Logins"

msgid "Personal logins and teams"
msgstr "Personal logins and teams"

msgid "Personal logins and teams the user is joined in"
msgstr "Personal logins and teams the user is joined in"

msgid "Phone"
msgstr "Phone"

msgctxt "KeeperImport"
msgid "Phone"
msgstr "Phone"

msgid "Phone connected"
msgstr "Phone connected"

msgid "Phone numbers"
msgstr "Phone numbers"

msgid "Photos"
msgstr "Photos"

msgid "Physical addresses"
msgstr "Physical addresses"

msgid "Physical attributes"
msgstr "Physical attributes"

msgid "PIN"
msgstr "PIN"

msgctxt "KeeperImport"
msgid "PIN code"
msgstr "PIN code"

msgid "PIN copied"
msgstr "PIN copied"

msgid "PIN inserted"
msgstr "PIN inserted"

msgid "PIN shown"
msgstr "PIN shown"

msgid "PINs"
msgstr "PINs"

msgid "Places of birth"
msgstr "Places of birth"

msgid "Plan"
msgstr "Plan"

msgid "Plan paused"
msgstr "Plan paused"

msgid "Please <0>contact support</0> if you want to delete your organization but have no access to heylogin."
msgstr "Please <0>contact support</0> if you want to delete your organization but have no access to heylogin."

msgid "Please <0>contact support</0>."
msgstr "Please <0>contact support</0>."

msgid "Please <0>create an account</0> first to file support requests."
msgstr "Please <0>create an account</0> first to file support requests."

msgid "Please check your <0>integration settings</0>."
msgstr "Please check your <0>integration settings</0>."

#. placeholder {0}: deletionInfo.organizationName
msgid "Please confirm the deletion by typing “<0>{0}</0>” in the field below. Please note that this action cannot be undone."
msgstr "Please confirm the deletion by typing “<0>{0}</0>” in the field below. Please note that this action cannot be undone."

msgid "Please enter a name"
msgstr "Please enter a name"

msgid "Please enter a password or select a key file"
msgstr "Please enter a password or select a key file"

msgid "Please grant heylogin access to use Swipe to Login."
msgstr "Please grant heylogin access to use Swipe to Login."

msgid "Please install a supported browser to use the autotype feature."
msgstr "Please install a supported browser to use the autotype feature."

msgid "Please install a supported browser to use the quick access feature."
msgstr "Please install a supported browser to use the quick access feature."

msgid "Please install the heylogin extension to use this feature."
msgstr "Please install the heylogin extension to use this feature."

msgid "Please make sure all managed organizations are assigned another delegated admin."
msgstr "Please make sure all managed organizations are assigned another delegated admin."

msgid "Please note: This integration only works with Google accounts that belong to a Google Workspace."
msgstr "Please note: This integration only works with Google accounts that belong to a Google Workspace."

msgid "Please select a file"
msgstr "Please select a file"

msgid "Please update your browser"
msgstr "Please update your browser"

msgid "Please update your heylogin browser extension to use this feature."
msgstr "Please update your heylogin browser extension to use this feature."

msgid "Political donations"
msgstr "Political donations"

msgid "Political views"
msgstr "Political views"

msgctxt "KeeperImport"
msgid "Port"
msgstr "Port"

msgid "Predefined roles"
msgstr "Predefined roles"

msgid "Press the keyboard shortcut in the desktop app to fill in the login."
msgstr "Press the keyboard shortcut in the desktop app to fill in the login."

msgid "Preview"
msgstr "Preview"

msgid "Previous"
msgstr "Previous"

msgid "Price"
msgstr "Price"

msgid "Privacy policy"
msgstr "Privacy policy"

msgid "Privacy Policy"
msgstr "Privacy Policy"

msgid "Private"
msgstr "Private"

msgid "Private account"
msgstr "Private account"

msgid "Private Account"
msgstr "Private Account"

msgctxt "KeeperImport"
msgid "Private key"
msgstr "Private key"

msgid "Private messages"
msgstr "Private messages"

msgid "Professional skills"
msgstr "Professional skills"

msgid "Profile photos"
msgstr "Profile photos"

msgid "Promote a second admin"
msgstr "Promote a second admin"

msgid "promote to admin"
msgstr "promote to admin"

msgid "Properties"
msgstr "Properties"

msgid "Protected by a swipe on your smartphone"
msgstr "Protected by a swipe on your smartphone"

msgid "Protected by your security key"
msgstr "Protected by your security key"

msgid "Proton Pass"
msgstr "Proton Pass"

msgctxt "KeeperImport"
msgid "Public key"
msgstr "Public key"

msgid "Purchases"
msgstr "Purchases"

msgid "Purchasing habits"
msgstr "Purchasing habits"

msgid "Pwnitoring"
msgstr "Pwnitoring"

msgid "Pwnitoring for company domains"
msgstr "Pwnitoring for company domains"

msgid "Pwnitoring is currently not available. Please try again later."
msgstr "Pwnitoring is currently not available. Please try again later."

msgctxt "KeeperImport"
msgid "Question"
msgstr "Question"

msgid "Quick Access"
msgstr "Quick Access"

msgid "Quick access window screenshot"
msgstr "Quick access window screenshot"

msgid "Races"
msgstr "Races"

msgid "Rate now"
msgstr "Rate now"

msgid "Rate us in the Chrome Web Store"
msgstr "Rate us in the Chrome Web Store"

msgid "Rate us in the Mac App Store"
msgstr "Rate us in the Mac App Store"

msgid "Rate us in the Microsoft Store"
msgstr "Rate us in the Microsoft Store"

msgid "Rate us on addons.mozilla.org"
msgstr "Rate us on addons.mozilla.org"

msgctxt "Read [access]"
msgid "Read"
msgstr "Read"

msgid "Read access"
msgstr "Read access"

msgid "Read access (Password hidden)"
msgstr "Read access (Password hidden)"

msgid "Really change your role?"
msgstr "Really change your role?"

msgid "Really delete login?"
msgstr "Really delete login?"

msgid "Really delete organization?"
msgstr "Really delete organization?"

msgid "Really delete team?"
msgstr "Really delete team?"

msgid "Really delete your login inbox?"
msgstr "Really delete your login inbox?"

msgid "Really leave beta?"
msgstr "Really leave beta?"

msgid "Really leave team?"
msgstr "Really leave team?"

msgid "Really remove shared login?"
msgstr "Really remove shared login?"

msgid "Really remove your own permissions?"
msgstr "Really remove your own permissions?"

msgid "Recipient should start with “age1”. Please use age-keygen to create a recipient."
msgstr "Recipient should start with “age1”. Please use age-keygen to create a recipient."

msgid "Reconnect"
msgstr "Reconnect"

msgid "Recovery email addresses"
msgstr "Recovery email addresses"

msgid "Recycle bin"
msgstr "Recycle bin"

msgid "Redeem for"
msgstr "Redeem for"

msgid "Redeem your coupon"
msgstr "Redeem your coupon"

msgid "Regenerate all vaults"
msgstr "Regenerate all vaults"

msgctxt "KeeperImport"
msgid "Region"
msgstr "Region"

msgid "Registration failed. Please reload the page to make sure you use the latest version of heylogin and try again"
msgstr "Registration failed. Please reload the page to make sure you use the latest version of heylogin and try again"

msgid "Registration with heylogin"
msgstr "Registration with heylogin"

msgid "Relationship statuses"
msgstr "Relationship statuses"

msgid "Religions"
msgstr "Religions"

msgid "Remove"
msgstr "Remove"

#. placeholder {0}: manager.email
msgid "Remove {0}?"
msgstr "Remove {0}?"

msgid "Remove filter"
msgstr "Remove filter"

msgid "Remove from team"
msgstr "Remove from team"

msgid "Remove group"
msgstr "Remove group"

msgid "Remove icon"
msgstr "Remove icon"

msgid "Remove managed organizations first"
msgstr "Remove managed organizations first"

msgid "Remove permissions"
msgstr "Remove permissions"

msgid "Removing…"
msgstr "Removing…"

msgid "Rename label"
msgstr "Rename label"

msgid "Request denied"
msgstr "Request denied"

msgid "Request failed"
msgstr "Request failed"

msgid "Request PIN from phone"
msgstr "Request PIN from phone"

msgid "Required characters"
msgstr "Required characters"

msgid "Resend email invites"
msgstr "Resend email invites"

msgid "Resend verification email"
msgstr "Resend verification email"

msgid "Resending…"
msgstr "Resending…"

msgid "Reset"
msgstr "Reset"

msgid "Reset to default"
msgstr "Reset to default"

msgid "Responsible organization"
msgstr "Responsible organization"

msgid "Restore"
msgstr "Restore"

msgid "Retry"
msgstr "Retry"

msgid "Revoking…"
msgstr "Revoking…"

msgid "Reward program balances"
msgstr "Reward program balances"

msgid "Role"
msgstr "Role"

msgid "Role editor"
msgstr "Role editor"

msgid "Role for new users"
msgstr "Role for new users"

msgid "Role name"
msgstr "Role name"

msgid "Roles"
msgstr "Roles"

msgctxt "KeeperImport"
msgid "Routing number"
msgstr "Routing number"

msgid "Safari"
msgstr "Safari"

msgid "Safari 14 is required for <0>Swipe to Login</0>"
msgstr "Safari 14 is required for <0>Swipe to Login</0>"

msgid "Safari 14 is required for Swipe to Login"
msgstr "Safari 14 is required for Swipe to Login"

msgctxt "Storybook"
msgid "Sales"
msgstr "Sales"

msgid "Salutations"
msgstr "Salutations"

msgid "Save"
msgstr "Save"

msgid "Save and move"
msgstr "Save and move"

msgid "Save and then move?"
msgstr "Save and then move?"

msgid "Save changes"
msgstr "Save changes"

msgid "Save the file by clicking “Save” and then “OK”."
msgstr "Save the file by clicking “Save” and then “OK”."

msgid "Saving"
msgstr "Saving"

msgid "Scan this QR code"
msgstr "Scan this QR code"

msgid "School grades (class levels)"
msgstr "School grades (class levels)"

msgid "Scroll to selection"
msgstr "Scroll to selection"

msgid "Search"
msgstr "Search"

msgid "Search accounts"
msgstr "Search accounts"

msgid "Search apps/platforms"
msgstr "Search apps/platforms"

msgid "Search entries"
msgstr "Search entries"

msgid "Search events"
msgstr "Search events"

msgid "Search groups"
msgstr "Search groups"

msgid "Search in all logins"
msgstr "Search in all logins"

msgid "Search organizations"
msgstr "Search organizations"

msgid "Search user"
msgstr "Search user"

msgid "Search users"
msgstr "Search users"

#. placeholder {0}: breachData.totalBreachCount
msgid "Searched accounts: <0>{localizedTotalPwnCountBillions} bn ({0} breaches)</0>"
msgstr "Searched accounts: <0>{localizedTotalPwnCountBillions} bn ({0} breaches)</0>"

msgid "Searching device"
msgstr "Searching device"

msgid "Searching for “{searchString}”"
msgstr "Searching for “{searchString}”"

msgctxt "KeeperImport"
msgid "Secret"
msgstr "Secret"

msgid "Secrets API"
msgstr "Secrets API"

msgid "Security"
msgstr "Security"

msgid "Security code copied"
msgstr "Security code copied"

msgid "Security code inserted"
msgstr "Security code inserted"

msgid "Security code shown"
msgstr "Security code shown"

msgid "Security key"
msgstr "Security key"

msgid "Security Key"
msgstr "Security Key"

#. placeholder {0}: status.name
msgid "Security key ({0})"
msgstr "Security key ({0})"

msgid "Security key connected"
msgstr "Security key connected"

msgid "Security key operation canceled."
msgstr "Security key operation canceled."

msgctxt "KeeperImport"
msgid "Security question"
msgstr "Security question"

msgid "Security questions and answers"
msgstr "Security questions and answers"

msgid "Select “.json” as file format (not “.json (Encrypted)”)."
msgstr "Select “.json” as file format (not “.json (Encrypted)”)."

msgid "Select “.json” as file format, and save the file."
msgstr "Select “.json” as file format, and save the file."

msgid "Select “Autofill” on the left side."
msgstr "Select “Autofill” on the left side."

msgid "Select “Export Logins...”."
msgstr "Select “Export Logins...”."

msgid "Select “Export Vault”."
msgstr "Select “Export Vault”."

msgid "Select “Export”."
msgstr "Select “Export”."

msgid "Select “File”, then “Export”."
msgstr "Select “File”, then “Export”."

msgid "Select “KeePass KDBX (2.x)”."
msgstr "Select “KeePass KDBX (2.x)”."

msgid "Select “Passwords”."
msgstr "Select “Passwords”."

msgctxt "EdgeImportGuide"
msgid "Select “Passwords”."
msgstr "Select “Passwords”."

msgid "Select “Settings”."
msgstr "Select “Settings”."

msgctxt "NordpassImportGuide"
msgid "Select “Settings”."
msgstr "Select “Settings”."

msgid "Select a CSV file"
msgstr "Select a CSV file"

msgid "Select a managing organization"
msgstr "Select a managing organization"

msgid "Select a role"
msgstr "Select a role"

msgid "Select a target"
msgstr "Select a target"

msgid "Select a target to move logins"
msgstr "Select a target to move logins"

msgid "Select a user"
msgstr "Select a user"

msgid "Select a user to transfer to"
msgstr "Select a user to transfer to"

msgid "Select all"
msgstr "Select all"

msgid "Select an image file"
msgstr "Select an image file"

msgid "Select at least one group"
msgstr "Select at least one group"

msgid "Select the tab “Export”."
msgstr "Select the tab “Export”."

msgid "Select users by status"
msgstr "Select users by status"

msgid "Select ZIP as the file format."
msgstr "Select ZIP as the file format."

msgid "Send again"
msgstr "Send again"

msgid "Send email invites"
msgstr "Send email invites"

msgid "Send feedback"
msgstr "Send feedback"

msgid "Send invite email"
msgstr "Send invite email"

msgid "Send request"
msgstr "Send request"

msgid "Sending request"
msgstr "Sending request"

msgid "Sending…"
msgstr "Sending…"

msgid "Service"
msgstr "Service"

msgid "Service application connected"
msgstr "Service application connected"

msgid "Service User"
msgstr "Service User"

msgid "Service User ID"
msgstr "Service User ID"

msgid "Set up"
msgstr "Set up"

msgid "Set up backup code"
msgstr "Set up backup code"

msgid "Set up Microsoft Entra ({stepIndex}/3)"
msgstr "Set up Microsoft Entra ({stepIndex}/3)"

msgid "Set up password policy"
msgstr "Set up password policy"

msgid "Set up security key"
msgstr "Set up security key"

msgid "Set up security key?"
msgstr "Set up security key?"

msgid "Set up Touch ID"
msgstr "Set up Touch ID"

msgid "Set up Touch ID?"
msgstr "Set up Touch ID?"

msgid "Set up Windows Hello"
msgstr "Set up Windows Hello"

msgid "Set up Windows Hello?"
msgstr "Set up Windows Hello?"

msgid "Set up your account"
msgstr "Set up your account"

msgid "Set up your security key"
msgstr "Set up your security key"

msgid "Set:"
msgstr "Set:"

msgid "Settings"
msgstr "Settings"

msgid "Setup failed in this browser. Please use Chrome to set up your security key. It will work in this browser afterwards"
msgstr "Setup failed in this browser. Please use Chrome to set up your security key. It will work in this browser afterwards"

msgid "Sexual fetishes"
msgstr "Sexual fetishes"

msgid "Sexual orientations"
msgstr "Sexual orientations"

msgid "Share link created"
msgstr "Share link created"

msgid "Share login"
msgstr "Share login"

msgid "Share logins with a simple, end-to-end encrypted API."
msgstr "Share logins with a simple, end-to-end encrypted API."

msgid "Shared by me"
msgstr "Shared by me"

msgid "Shared secret created"
msgstr "Shared secret created"

msgid "Shared with {profiles, plural, one {# user} other {# users}} and {vaults, plural, one {# team} other {# teams}}."
msgstr "Shared with {profiles, plural, one {# user} other {# users}} and {vaults, plural, one {# team} other {# teams}}."

msgid "Shared with {profiles, plural, one {# user} other {# users}}."
msgstr "Shared with {profiles, plural, one {# user} other {# users}}."

msgid "Shared with {vaults, plural, one {# team} other {# teams}}."
msgstr "Shared with {vaults, plural, one {# team} other {# teams}}."

msgid "Shared with me"
msgstr "Shared with me"

msgid "Shared with:"
msgstr "Shared with:"

msgid "Shortcut:"
msgstr "Shortcut:"

msgid "Show"
msgstr "Show"

msgid "Show backup code"
msgstr "Show backup code"

msgid "Show details"
msgstr "Show details"

msgid "Show edit history"
msgstr "Show edit history"

msgid "Show emails"
msgstr "Show emails"

msgid "Show instructions"
msgstr "Show instructions"

msgid "Show logins on mobile devices"
msgstr "Show logins on mobile devices"

msgid "Show organization"
msgstr "Show organization"

msgid "Show personal logins on mobile devices"
msgstr "Show personal logins on mobile devices"

msgid "Show start codes"
msgstr "Show start codes"

msgid "simon@example.com"
msgstr "simon@example.com"

msgid "Simplify the login process in your team"
msgstr "Simplify the login process in your team"

msgid "Simplify your login process"
msgstr "Simplify your login process"

msgid "Simply get the app and create your heylogin account, and you can redeem your coupon on this page."
msgstr "Simply get the app and create your heylogin account, and you can redeem your coupon on this page."

msgid "Skip warning"
msgstr "Skip warning"

msgid "Skipped entries"
msgstr "Skipped entries"

msgid "Smoking habits"
msgstr "Smoking habits"

msgid "SMS messages"
msgstr "SMS messages"

msgid "Social connections"
msgstr "Social connections"

msgid "Social media profiles"
msgstr "Social media profiles"

msgid "Social security numbers"
msgstr "Social security numbers"

msgid "Some organization members are not displayed because their login device is disconnected."
msgstr "Some organization members are not displayed because their login device is disconnected."

msgid "Something went wrong accessing your Entra tenant."
msgstr "Something went wrong accessing your Entra tenant."

msgid "Something went wrong accessing your Google Workspace."
msgstr "Something went wrong accessing your Google Workspace."

msgid "Something went wrong while setting up your security key."
msgstr "Something went wrong while setting up your security key."

msgid "Sort by:"
msgstr "Sort by:"

msgid "Spoken languages"
msgstr "Spoken languages"

msgid "Spouses' names"
msgstr "Spouses' names"

msgid "SSH keys are not supported. Please use age-keygen to create a recipient."
msgstr "SSH keys are not supported. Please use age-keygen to create a recipient."

msgid "Start code"
msgstr "Start code"

#. placeholder {0}: profileIndex + 1
#. placeholder {1}: profileStartCodes.length
msgid "Start code {0} of {1}"
msgstr "Start code {0} of {1}"

msgid "Start code expired after 30 days"
msgstr "Start code expired after 30 days"

msgid "Start code for:"
msgstr "Start code for:"

#. placeholder {0}: userGroup.changeRelativeDate
msgid "Start code generated {0}"
msgstr "Start code generated {0}"

msgid "Start code generated at {formattedStartCodeGeneratedDate}"
msgstr "Start code generated at {formattedStartCodeGeneratedDate}"

msgid "Start code may not be empty!"
msgstr "Start code may not be empty!"

msgctxt "KeeperImport"
msgid "State"
msgstr "State"

msgid "Status"
msgstr "Status"

msgid "STEP {step}"
msgstr "STEP {step}"

msgid "Step 1 - Download app"
msgstr "Step 1 - Download app"

msgid "Step 1 - Receive start code"
msgstr "Step 1 - Receive start code"

msgid "Step 2 - Connect app via PIN"
msgstr "Step 2 - Connect app via PIN"

msgid "Step 2 - Enter company email"
msgstr "Step 2 - Enter company email"

msgid "Step 2 - Scan the QR code"
msgstr "Step 2 - Scan the QR code"

msgid "StickyPassword"
msgstr "StickyPassword"

msgctxt "KeeperImport"
msgid "Street address line 1"
msgstr "Street address line 1"

msgctxt "KeeperImport"
msgid "Street address line 2"
msgstr "Street address line 2"

msgid "Subject"
msgstr "Subject"

msgid "Subject may not be empty!"
msgstr "Subject may not be empty!"

msgid "Successfully connected"
msgstr "Successfully connected"

msgid "Support by e-mail"
msgstr "Support by e-mail"

msgid "Support by phone"
msgstr "Support by phone"

msgid "Support tickets"
msgstr "Support tickets"

msgid "Survey results"
msgstr "Survey results"

msgid "Swipe to login"
msgstr "Swipe to login"

msgid "Swipe to Login"
msgstr "Swipe to Login"

msgid "Swipe to Login is not available in this browser"
msgstr "Swipe to Login is not available in this browser"

msgid "Sync existing Accounts"
msgstr "Sync existing Accounts"

msgid "Synced"
msgstr "Synced"

msgid "Synchronize groups"
msgstr "Synchronize groups"

msgid "Synchronize groups in heylogin"
msgstr "Synchronize groups in heylogin"

msgid "Synchronize users from Entra ID to heylogin automatically."
msgstr "Synchronize users from Entra ID to heylogin automatically."

msgid "Syncing…"
msgstr "Syncing…"

msgid "System-wide access to this feature is only supported in Chrome and Microsoft Edge."
msgstr "System-wide access to this feature is only supported in Chrome and Microsoft Edge."

msgid "Tags"
msgstr "Tags"

msgid "Tap “heylogin – Password Manager” again"
msgstr "Tap “heylogin – Password Manager” again"

msgid "Tap <0>“<1/>”</0> in the address bar"
msgstr "Tap <0>“<1/>”</0> in the address bar"

msgid "Target"
msgstr "Target"

msgid "Target user"
msgstr "Target user"

msgid "Target users"
msgstr "Target users"

#. placeholder {0}: getFullLoginVaultLabel(entry.targetVaultMetadata, entry.organizationMetadata)
msgid "Target: <0>{0}</0>"
msgstr "Target: <0>{0}</0>"

msgid "Taxation records"
msgstr "Taxation records"

msgid "Team"
msgstr "Team"

msgid "Team (heylogin)"
msgstr "Team (heylogin)"

msgid "Team Admin"
msgstr "Team Admin"

msgid "Team description"
msgstr "Team description"

msgid "Team management"
msgstr "Team management"

msgid "Team name"
msgstr "Team name"

msgid "Team name may not be empty!"
msgstr "Team name may not be empty!"

msgid "Team settings"
msgstr "Team settings"

msgid "Team users are automatically provisioned from a <0>group in Microsoft Entra</0>."
msgstr "Team users are automatically provisioned from a <0>group in Microsoft Entra</0>."

msgid "Teams"
msgstr "Teams"

msgid "Teams (heylogin)"
msgstr "Teams (heylogin)"

msgid "Telecommunications carrier"
msgstr "Telecommunications carrier"

msgid "Terms of use"
msgstr "Terms of use"

msgid "Terms of Use"
msgstr "Terms of Use"

msgid "Test phase"
msgstr "Test phase"

msgctxt "KeeperImport"
msgid "Text"
msgstr "Text"

msgid "Text line 1"
msgstr "Text line 1"

msgid "Text line 2"
msgstr "Text line 2"

msgid "Thank you"
msgstr "Thank you"

msgid "Thank you for your feedback"
msgstr "Thank you for your feedback"

msgid "Thank you for your purchase."
msgstr "Thank you for your purchase."

msgid "The account will still be usable"
msgstr "The account will still be usable"

msgid "The additional licenses are available <0>now</0>. An order confirmation will be sent to you soon."
msgstr "The additional licenses are available <0>now</0>. An order confirmation will be sent to you soon."

msgid "The additional licenses will be available <0>immediately</0>."
msgstr "The additional licenses will be available <0>immediately</0>."

msgid "The additional licenses will be billed according to the terms of your contract."
msgstr "The additional licenses will be billed according to the terms of your contract."

msgid "The admin role can always manage users"
msgstr "The admin role can always manage users"

msgid "The admin role can always view the user list"
msgstr "The admin role can always view the user list"

msgid "The authorization has been revoked"
msgstr "The authorization has been revoked"

msgid "The authorization was canceled"
msgstr "The authorization was canceled"

msgid "The backup code lets you set up heylogin if you lose access to your login devices."
msgstr "The backup code lets you set up heylogin if you lose access to your login devices."

msgid "The CSV file is missing an email column"
msgstr "The CSV file is missing an email column"

msgid "The CSV file should have the following format:"
msgstr "The CSV file should have the following format:"

msgid "The default password policy follows recommendations from the <0>CIS Password Policy Guide</0> and <1>NIST SP 800-63B</1>."
msgstr "The default password policy follows recommendations from the <0>CIS Password Policy Guide</0> and <1>NIST SP 800-63B</1>."

msgid "The delegated admin role can always manage users"
msgstr "The delegated admin role can always manage users"

msgid "The delegated admin role can always view the user list"
msgstr "The delegated admin role can always view the user list"

msgid "The deletion request for this organization has been cancelled."
msgstr "The deletion request for this organization has been cancelled."

msgid "The device you used is not supported. Please use a FIDO2 compatible USB key."
msgstr "The device you used is not supported. Please use a FIDO2 compatible USB key."

msgid "The displayed data might be outdated."
msgstr "The displayed data might be outdated."

msgid "The edit history of all logins you have access to will be deleted. The previous versions can not be restored!"
msgstr "The edit history of all logins you have access to will be deleted. The previous versions can not be restored!"

msgid "The email address is already taken."
msgstr "The email address is already taken."

msgid "The email address is not valid."
msgstr "The email address is not valid."

msgid "The file contains a column named “email”"
msgstr "The file contains a column named “email”"

msgid "The first line is a header line"
msgstr "The first line is a header line"

msgid "The import is not yet finished, really close?"
msgstr "The import is not yet finished, really close?"

msgid "The import target does not exist"
msgstr "The import target does not exist"

msgid "The login inbox “{slug}” does not exist"
msgstr "The login inbox “{slug}” does not exist"

msgid "The login was cancelled from your smartphone"
msgstr "The login was cancelled from your smartphone"

msgid "The managing organization will have full access to this organization."
msgstr "The managing organization will have full access to this organization."

msgid "The Microsoft Entra integration for heylogin allows you to mirror your Entra tenant in heylogin."
msgstr "The Microsoft Entra integration for heylogin allows you to mirror your Entra tenant in heylogin."

msgid "The organization “{name}” will be deleted irrecoverably."
msgstr "The organization “{name}” will be deleted irrecoverably."

msgid "The organization can also be recovered from its managing organization"
msgstr "The organization can also be recovered from its managing organization"

msgid "The organization has been deleted with all its data."
msgstr "The organization has been deleted with all its data."

msgid "The organization needs at least one admin."
msgstr "The organization needs at least one admin."

msgid "The password and other protected fields are hidden from members with the read-only permission, and can not be copied. Logins can only be used to log in on websites. <0>Learn more</0>"
msgstr "The password and other protected fields are hidden from members with the read-only permission, and can not be copied. Logins can only be used to log in on websites. <0>Learn more</0>"

msgid "The password and other protected fields will be hidden from the recipient, and can not be copied. The login can only be used to log in on websites. <0>Learn more</0>"
msgstr "The password and other protected fields will be hidden from the recipient, and can not be copied. The login can only be used to log in on websites. <0>Learn more</0>"

#. placeholder {0}: childOrganization.name
msgid "The personal logins in “{0}” will be deleted."
msgstr "The personal logins in “{0}” will be deleted."

msgid "The plan could not be activated due to a license issue. Please contact support."
msgstr "The plan could not be activated due to a license issue. Please contact support."

msgid "The recycle bin is empty"
msgstr "The recycle bin is empty"

msgid "The role you selected does not have the permission to change roles. You will be unable to undo this yourself."
msgstr "The role you selected does not have the permission to change roles. You will be unable to undo this yourself."

msgid "The security key will be able to unlock all your devices."
msgstr "The security key will be able to unlock all your devices."

msgid "The selected user/email doesn't exist in your heylogin organization at the moment. Create the user now."
msgstr "The selected user/email doesn't exist in your heylogin organization at the moment. Create the user now."

msgid "The server could not be reached."
msgstr "The server could not be reached."

msgid "The server could not be reached. Please make sure you have connection to the internet and try again in a few minutes."
msgstr "The server could not be reached. Please make sure you have connection to the internet and try again in a few minutes."

msgid "The settings changes do not affect these users"
msgstr "The settings changes do not affect these users"

msgid "The setup was canceled."
msgstr "The setup was canceled."

msgid "The start code for this account is no longer valid. Ask your admin to create a new one."
msgstr "The start code for this account is no longer valid. Ask your admin to create a new one."

msgid "The team “{truncatedName}” will be deleted irrecoverably."
msgstr "The team “{truncatedName}” will be deleted irrecoverably."

#. placeholder {0}: organization.name
msgid "The team “Delegated Admins” in {0} will be deleted irrecoverably."
msgstr "The team “Delegated Admins” in {0} will be deleted irrecoverably."

msgid "The tenant data is currently unavailable"
msgstr "The tenant data is currently unavailable"

msgid "The upload is not yet finished, really close?"
msgstr "The upload is not yet finished, really close?"

msgid "The user does not exist."
msgstr "The user does not exist."

msgid "The verification link is invalid"
msgstr "The verification link is invalid"

msgid "their personal logins"
msgstr "their personal logins"

msgid "There are currently issues with the LastPass export from the website (see this <0>Reddit thread</0>). If possible, export your data using the LastPass web extension in Google Chrome."
msgstr "There are currently issues with the LastPass export from the website (see this <0>Reddit thread</0>). If possible, export your data using the LastPass web extension in Google Chrome."

msgid "There are no entries with this label. You can <0>add a new entry</0> to fill it."
msgstr "There are no entries with this label. You can <0>add a new entry</0> to fill it."

msgid "There are no known breaches for any of the monitored domains."
msgstr "There are no known breaches for any of the monitored domains."

msgid "There is no account with the given email address"
msgstr "There is no account with the given email address"

msgid "There is no phone connected to this account."
msgstr "There is no phone connected to this account."

msgid "There is no security key connected to this account or the security key is not configured to connect new devices. Please contact your organization admin to get access to the account."
msgstr "There is no security key connected to this account or the security key is not configured to connect new devices. Please contact your organization admin to get access to the account."

msgid "There is no security key connected to this account or the security key is not configured to connect new devices. Please use your phone to connect new devices."
msgstr "There is no security key connected to this account or the security key is not configured to connect new devices. Please use your phone to connect new devices."

msgid "There must always be at least one admin or delegated admin for an organization. To remove the last delegated admin, give admin permission to one of the users in this managed organization."
msgstr "There must always be at least one admin or delegated admin for an organization. To remove the last delegated admin, give admin permission to one of the users in this managed organization."

msgid "There was a permission error. Please reconnect."
msgstr "There was a permission error. Please reconnect."

msgid "There was an error during import. {pleaseUpdate}"
msgstr "There was an error during import. {pleaseUpdate}"

msgid "There was an error sending the support request. Please try again or send an email to <0>support@heylogin.com</0>."
msgstr "There was an error sending the support request. Please try again or send an email to <0>support@heylogin.com</0>."

msgid "These settings are enabled for you due to an ongoing support case. Please <0>contact support</0> once the issue is resolved."
msgstr "These settings are enabled for you due to an ongoing support case. Please <0>contact support</0> once the issue is resolved."

msgid "These users cannot be removed:"
msgstr "These users cannot be removed:"

msgid "This account can't be used with a security key."
msgstr "This account can't be used with a security key."

msgid "This account is already connected. Please contact your admin."
msgstr "This account is already connected. Please contact your admin."

msgid "This account was deleted. Please contact your admin."
msgstr "This account was deleted. Please contact your admin."

msgid "This address already belongs to an account. Contact your admin to get access to the account."
msgstr "This address already belongs to an account. Contact your admin to get access to the account."

msgid "This address already belongs to an account. If this is your account, contact your admin to regain access."
msgstr "This address already belongs to an account. If this is your account, contact your admin to regain access."

msgid "This address belongs to an organization. An admin of that organization must set up an account for you to use."
msgstr "This address belongs to an organization. An admin of that organization must set up an account for you to use."

msgid "This address is already in use"
msgstr "This address is already in use"

msgid "This address is already in use. If you have lost your login device you can restore your accounts using your backup code."
msgstr "This address is already in use. If you have lost your login device you can restore your accounts using your backup code."

msgid "This address is already in use. If you have lost your login device, please contact support."
msgstr "This address is already in use. If you have lost your login device, please contact support."

msgid "This contact information is shown in heylogin and serves users as their point of contact in case of questions or problems."
msgstr "This contact information is shown in heylogin and serves users as their point of contact in case of questions or problems."

msgid "This coupon code is not compatible with the current license"
msgstr "This coupon code is not compatible with the current license"

msgid "This coupon has already been redeemed"
msgstr "This coupon has already been redeemed"

msgid "This creates an export of all teams in your organization, including teams that you are not a member of."
msgstr "This creates an export of all teams in your organization, including teams that you are not a member of."

msgid "This email address already belongs to an organization. Please contact your admin to receive a start code."
msgstr "This email address already belongs to an organization. Please contact your admin to receive a start code."

msgid "This email address belongs to an organization. It can't be used to set up a private account."
msgstr "This email address belongs to an organization. It can't be used to set up a private account."

msgid "This email address has no associated start code. Please contact your admin."
msgstr "This email address has no associated start code. Please contact your admin."

msgid "This email address is already taken."
msgstr "This email address is already taken."

msgid "This email address is reserved by an organization."
msgstr "This email address is reserved by an organization."

msgid "This email address is reserved in another organization."
msgstr "This email address is reserved in another organization."

msgid "This feature is not supported by your browser ({browserDescription})."
msgstr "This feature is not supported by your browser ({browserDescription})."

msgid "This feature is not supported by your browser."
msgstr "This feature is not supported by your browser."

msgid "This feature is only available on Microsoft Windows"
msgstr "This feature is only available on Microsoft Windows"

msgid "This information will be displayed to identify you as the owner of <0>{displayLink}</0>"
msgstr "This information will be displayed to identify you as the owner of <0>{displayLink}</0>"

msgid "This is a service user. It can be connected to the heylogin backup client to perform an on-premises backup of your organization."
msgstr "This is a service user. It can be connected to the heylogin backup client to perform an on-premises backup of your organization."

msgid "This is how heylogin works everywhere"
msgstr "This is how heylogin works everywhere"

msgid "This is how you activate 1-click login for your iPhone or iPad"
msgstr "This is how you activate 1-click login for your iPhone or iPad"

msgid "This login has unsaved changes"
msgstr "This login has unsaved changes"

msgid "This login uses the login scopes beta."
msgstr "This login uses the login scopes beta."

msgid "This looks like a start code. To join an existing organization, use the “Join” tab."
msgstr "This looks like a start code. To join an existing organization, use the “Join” tab."

msgid "This may be related to missing support by your browser or operating system."
msgstr "This may be related to missing support by your browser or operating system."

msgid "This may take a few minutes."
msgstr "This may take a few minutes."

msgid "This operation cannot be undone."
msgstr "This operation cannot be undone."

msgid "This organization deletion link is invalid."
msgstr "This organization deletion link is invalid."

msgid "This organization has already been deleted."
msgstr "This organization has already been deleted."

#. placeholder {0}: parentOrganizationInfo.name
msgid "This organization is managed by <0>{0}</0>."
msgstr "This organization is managed by <0>{0}</0>."

msgid "This organization still has managed organizations. To delete it, remove the managed organizations first"
msgstr "This organization still has managed organizations. To delete it, remove the managed organizations first"

msgid "This role can always recover the organization."
msgstr "This role can always recover the organization."

msgid "This role is still assigned to users"
msgstr "This role is still assigned to users"

msgid "This role is used for service users. The permissions for this role cannot be changed."
msgstr "This role is used for service users. The permissions for this role cannot be changed."

#. placeholder {0}: unlockTimeOrgCap.orgName
msgid "This setting is limited by “{0}”."
msgstr "This setting is limited by “{0}”."

msgid "This team is currently empty. Other team members can add new entries for you to use."
msgstr "This team is currently empty. Other team members can add new entries for you to use."

msgid "This team is empty. You can <0>import entries</0> or <1>add a new entry</1> to fill it."
msgstr "This team is empty. You can <0>import entries</0> or <1>add a new entry</1> to fill it."

msgid "This team is synchronized automatically."
msgstr "This team is synchronized automatically."

msgid "This user does not have a private account."
msgstr "This user does not have a private account."

msgid "This user is already a member of this organization."
msgstr "This user is already a member of this organization."

msgid "This user is already a member of this organization. Remove or reassign them in the organization management."
msgstr "This user is already a member of this organization. Remove or reassign them in the organization management."

msgid "This user needs to update their account to allow login sharing. Please instruct the user to visit heylogin.app to perform the update."
msgstr "This user needs to update their account to allow login sharing. Please instruct the user to visit heylogin.app to perform the update."

msgid "This will delete all your login inboxes and all logins contained in them."
msgstr "This will delete all your login inboxes and all logins contained in them."

msgid "Time"
msgstr "Time"

msgid "Time until device lock can be selected by user, up to 8 hours."
msgstr "Time until device lock can be selected by user, up to 8 hours."

msgid "Time zones"
msgstr "Time zones"

msgid "Title"
msgstr "Title"

msgid "To be able to use the quick access outside your browser as well, make sure to set the keyboard shortcut to “Global”."
msgstr "To be able to use the quick access outside your browser as well, make sure to set the keyboard shortcut to “Global”."

msgid "To change your billing email, please <0>contact support</0>."
msgstr "To change your billing email, please <0>contact support</0>."

msgid "To connect your security key and gain access again, you will need a new start code from your admin."
msgstr "To connect your security key and gain access again, you will need a new start code from your admin."

msgid "To continue using heylogin, please continue your heylogin plan."
msgstr "To continue using heylogin, please continue your heylogin plan."

msgid "To continue using heylogin, please upgrade your plan."
msgstr "To continue using heylogin, please upgrade your plan."

msgid "To continue using team features after that date, please upgrade your plan."
msgstr "To continue using team features after that date, please upgrade your plan."

msgid "To continue using team features after the trial, please upgrade your plan."
msgstr "To continue using team features after the trial, please upgrade your plan."

msgid "To continue using team features, please upgrade your plan."
msgstr "To continue using team features, please upgrade your plan."

msgid "To delete this organization, you must remove all managed organizations first."
msgstr "To delete this organization, you must remove all managed organizations first."

msgid "to log in"
msgstr "to log in"

msgid "to Opera from the Chrome Web Store"
msgstr "to Opera from the Chrome Web Store"

msgid "To purchase more than 100 additional licenses, please contact sales"
msgstr "To purchase more than 100 additional licenses, please contact sales"

msgid "To redeem your coupon, open this website on your PC or Mac."
msgstr "To redeem your coupon, open this website on your PC or Mac."

msgid "To register with a security key, you need a start code or an email invite from your admin."
msgstr "To register with a security key, you need a start code or an email invite from your admin."

msgid "To use a different heylogin account on this device, you'll need to disconnect your security key."
msgstr "To use a different heylogin account on this device, you'll need to disconnect your security key."

msgid "To use all of heylogin's features, add the browser extension."
msgstr "To use all of heylogin's features, add the browser extension."

msgid "To use Swipe to Login on this device, add the heylogin <0>browser extension</0> {installFromStore}."
msgstr "To use Swipe to Login on this device, add the heylogin <0>browser extension</0> {installFromStore}."

msgid "today"
msgstr "today"

msgid "tomorrow"
msgstr "tomorrow"

msgid "Too few fields"
msgstr "Too few fields"

msgid "Too many failed attempts. Try again tomorrow or ask your admin to generate a new start code."
msgstr "Too many failed attempts. Try again tomorrow or ask your admin to generate a new start code."

msgid "Total imported logins"
msgstr "Total imported logins"

msgid "Total number of entries"
msgstr "Total number of entries"

msgid "Total sync users"
msgstr "Total sync users"

msgid "TOTP secret"
msgstr "TOTP secret"

msgid "TOTP secret shown"
msgstr "TOTP secret shown"

msgid "Touch ID (macOS)"
msgstr "Touch ID (macOS)"

msgid "Transfer another login"
msgstr "Transfer another login"

msgid "Transfer encrypted login"
msgstr "Transfer encrypted login"

#. placeholder {0}: transferTarget.email
msgid "Transfer login to {0}"
msgstr "Transfer login to {0}"

msgid "Transfer to personal logins of"
msgstr "Transfer to personal logins of"

msgid "Transfer to user"
msgstr "Transfer to user"

msgid "Transferred logins will be listed here. You can then drag and drop them into teams or your personal logins."
msgstr "Transferred logins will be listed here. You can then drag and drop them into teams or your personal logins."

msgid "Transferring…"
msgstr "Transferring…"

msgid "Trashed"
msgstr "Trashed"

msgid "Travel habits"
msgstr "Travel habits"

msgid "Trial expired"
msgstr "Trial expired"

msgid "Troubleshooting"
msgstr "Troubleshooting"

msgctxt "unlocking"
msgid "Try again"
msgstr "Try again"

msgid "two hours"
msgstr "two hours"

msgctxt "KeeperImport"
msgid "Two-factor code"
msgstr "Two-factor code"

msgctxt "KeeperImport"
msgid "Type"
msgstr "Type"

msgid "Types"
msgstr "Types"

msgid "Unchanged users"
msgstr "Unchanged users"

msgid "Undo"
msgstr "Undo"

msgid "Unknown"
msgstr "Unknown"

msgid "Unknown Browser"
msgstr "Unknown Browser"

msgid "Unknown device"
msgstr "Unknown device"

msgid "Unknown event"
msgstr "Unknown event"

msgid "Unknown field"
msgstr "Unknown field"

msgid "Unknown login"
msgstr "Unknown login"

msgid "Unknown login location"
msgstr "Unknown login location"

msgid "Unknown Operating System"
msgstr "Unknown Operating System"

msgid "Unknown Organization"
msgstr "Unknown Organization"

msgid "Unknown password policy"
msgstr "Unknown password policy"

msgid "Unknown role"
msgstr "Unknown role"

msgid "Unknown time"
msgstr "Unknown time"

msgid "Unknown user"
msgstr "Unknown user"

msgid "Unknown value"
msgstr "Unknown value"

msgid "Unlock"
msgstr "Unlock"

msgid "Unlock license"
msgstr "Unlock license"

msgid "Unlock your heylogin license"
msgstr "Unlock your heylogin license"

msgid "Unnamed role"
msgstr "Unnamed role"

msgid "Unnamed Team"
msgstr "Unnamed Team"

msgid "Unverified"
msgstr "Unverified"

msgid "up to"
msgstr "up to"

msgid "Update"
msgstr "Update"

msgid "Update monitored domains"
msgstr "Update monitored domains"

msgid "Update Safari now"
msgstr "Update Safari now"

msgid "Upgrade later"
msgstr "Upgrade later"

msgid "Upgrade now"
msgstr "Upgrade now"

msgid "Upgrade plan"
msgstr "Upgrade plan"

msgid "Upgrade to business"
msgstr "Upgrade to business"

msgid "Upload"
msgstr "Upload"

msgid "Upload CSV file"
msgstr "Upload CSV file"

msgctxt "KeeperImport"
msgid "URL"
msgstr "URL"

msgid "Use a security key"
msgstr "Use a security key"

msgid "Use Entra groups as heylogin teams to mirror your organizational structure in heylogin."
msgstr "Use Entra groups as heylogin teams to mirror your organizational structure in heylogin."

msgid "Use existing account"
msgstr "Use existing account"

msgid "Use heylogin for your private logins"
msgstr "Use heylogin for your private logins"

msgid "Use passkeys to log in to websites that support passwordless authentication."
msgstr "Use passkeys to log in to websites that support passwordless authentication."

msgid "Use quick access to get easier access to your logins for native apps."
msgstr "Use quick access to get easier access to your logins for native apps."

msgid "Use the new format for the scope of logins (websites, Android apps, Windows apps). Logins will be converted to the new format the next time you edit them."
msgstr "Use the new format for the scope of logins (websites, Android apps, Windows apps). Logins will be converted to the new format the next time you edit them."

msgid "Use your FIDO2 compatible security key"
msgstr "Use your FIDO2 compatible security key"

msgid "User"
msgstr "User"

msgid "User created"
msgstr "User created"

msgid "User deleted"
msgstr "User deleted"

msgid "User demoted from admin"
msgstr "User demoted from admin"

msgid "User disconnected"
msgstr "User disconnected"

msgid "User joined"
msgstr "User joined"

msgid "User Management"
msgstr "User Management"

msgid "User not found."
msgstr "User not found."

msgid "User promoted to admin"
msgstr "User promoted to admin"

msgid "User settings"
msgstr "User settings"

msgid "User statuses"
msgstr "User statuses"

msgid "User website URLs"
msgstr "User website URLs"

msgid "User/Email"
msgstr "User/Email"

msgid "Username or e-mail address"
msgstr "Username or e-mail address"

msgid "Usernames"
msgstr "Usernames"

msgid "Users"
msgstr "Users"

msgid "Users and teams"
msgstr "Users and teams"

msgid "Users disabled in Entra will be disconnected in heylogin"
msgstr "Users disabled in Entra will be disconnected in heylogin"

msgid "Users suggested for creation"
msgstr "Users suggested for creation"

msgid "Utility bills"
msgstr "Utility bills"

msgid "Vault name"
msgstr "Vault name"

msgid "Vehicle details"
msgstr "Vehicle details"

msgid "Vehicle identification numbers (VINs)"
msgstr "Vehicle identification numbers (VINs)"

msgid "Verification email resent!"
msgstr "Verification email resent!"

msgid "Verification email sent"
msgstr "Verification email sent"

msgid "Verify your email address to create a login inbox."
msgstr "Verify your email address to create a login inbox."

msgid "Verify your email address to update your login inbox link."
msgstr "Verify your email address to update your login inbox link."

msgid "Version of {formattedEditTime}, after edit by {editProfileEmail}."
msgstr "Version of {formattedEditTime}, after edit by {editProfileEmail}."

msgid "Version of {formattedEditTime}."
msgstr "Version of {formattedEditTime}."

msgid "View all managed organizations"
msgstr "View all managed organizations"

msgid "View Auditlog"
msgstr "View Auditlog"

msgid "View feature"
msgstr "View feature"

msgid "View Pwnitoring"
msgstr "View Pwnitoring"

msgid "View user list"
msgstr "View user list"

#. placeholder {0}: events.length
msgid "Viewing {0} out of {totalEvents} events"
msgstr "Viewing {0} out of {totalEvents} events"

msgid "We could not establish a connection to the secure device."
msgstr "We could not establish a connection to the secure device."

msgid "We don't use tracking cookies. Could you help out our marketing person?"
msgstr "We don't use tracking cookies. Could you help out our marketing person?"

msgid "We sent an email for verification to {emailAddress}."
msgstr "We sent an email for verification to {emailAddress}."

msgid "We will reply as soon as possible to <0>{email}</0>"
msgstr "We will reply as soon as possible to <0>{email}</0>"

msgid "We will reply to"
msgstr "We will reply to"

msgid "Website"
msgstr "Website"

msgid "Website activity"
msgstr "Website activity"

msgid "Website login"
msgstr "Website login"

msgid "Welcome"
msgstr "Welcome"

msgid "Welcome back!"
msgstr "Welcome back!"

msgid "Welcome to heylogin!"
msgstr "Welcome to heylogin!"

msgid "Wi-Fi network name (SSID)"
msgstr "Wi-Fi network name (SSID)"

msgid "Wi-Fi QR code shown"
msgstr "Wi-Fi QR code shown"

msgid "Windows Hello"
msgstr "Windows Hello"

msgid "With a login inbox you can easily and securely receive logins from your customers."
msgstr "With a login inbox you can easily and securely receive logins from your customers."

msgid "With a security key"
msgstr "With a security key"

msgid "With an active password policy, users in the organization are warned if their passwords violate it."
msgstr "With an active password policy, users in the organization are warned if their passwords violate it."

msgid "With heylogin you can securely and easily transmit your logins"
msgstr "With heylogin you can securely and easily transmit your logins"

msgid "With heylogin.me you can create an inbox to receive logins. Your customers can send their securely encrypted logins directly to your inbox via a link."
msgstr "With heylogin.me you can create an inbox to receive logins. Your customers can send their securely encrypted logins directly to your inbox via a link."

msgid "With my phone"
msgstr "With my phone"

msgid "With our audit log, admins get an overview of all activities in their heylogin organization. This way, they stay on top of all changes and can act immediately on abuse of confidence."
msgstr "With our audit log, admins get an overview of all activities in their heylogin organization. This way, they stay on top of all changes and can act immediately on abuse of confidence."

msgid "with the heylogin app"
msgstr "with the heylogin app"

msgid "With your feedback we improve heylogin every day. Thank you!"
msgstr "With your feedback we improve heylogin every day. Thank you!"

msgid "Work habits"
msgstr "Work habits"

msgctxt "Write [access]"
msgid "Write"
msgstr "Write"

msgid "Write access"
msgstr "Write access"

msgid "Write down your backup code"
msgstr "Write down your backup code"

msgid "Yearly"
msgstr "Yearly"

msgid "Years of professional experience"
msgstr "Years of professional experience"

msgid "yesterday"
msgstr "yesterday"

msgid "You"
msgstr "You"

msgid "You are already a member of this organization."
msgstr "You are already a member of this organization."

msgid "You are currently not managing any organizations"
msgstr "You are currently not managing any organizations"

msgid "You are just three steps away from unlocking your license coupon for heylogin!"
msgstr "You are just three steps away from unlocking your license coupon for heylogin!"

msgid "You are logged out"
msgstr "You are logged out"

msgid "You can also <0>check out our help center</0> for answers to common questions."
msgstr "You can also <0>check out our help center</0> for answers to common questions."

msgid "You can look at your logins and manage them here"
msgstr "You can look at your logins and manage them here"

msgid "You can not disconnect your own login device."
msgstr "You can not disconnect your own login device."

msgid "You can now close this tab."
msgstr "You can now close this tab."

msgid "You can now log in on any website with 1-click login."
msgstr "You can now log in on any website with 1-click login."

msgid "You can now make sync settings"
msgstr "You can now make sync settings"

msgid "You can only add a new security key if you've logged in recently. Please <0>log out</0>, then log in and try again."
msgstr "You can only add a new security key if you've logged in recently. Please <0>log out</0>, then log in and try again."

msgid "You can only delete this organization if you are the last remaining admin."
msgstr "You can only delete this organization if you are the last remaining admin."

msgid "You can't leave the organization because that would leave it without an admin. Please give another user admin permissions and try again. If you want to delete the organization, you can do so in the <0>organization settings</0>."
msgstr "You can't leave the organization because that would leave it without an admin. Please give another user admin permissions and try again. If you want to delete the organization, you can do so in the <0>organization settings</0>."

msgid "You can't remove your only security key. If you want to use another heylogin account on this device, you can disconnect in <0>account settings</0>."
msgstr "You can't remove your only security key. If you want to use another heylogin account on this device, you can disconnect in <0>account settings</0>."

#. placeholder {0}: skippedVaults[0].label
msgid "You cannot export from “{0}”, because you are not allowed to see passwords. Please contact the team admin."
msgstr "You cannot export from “{0}”, because you are not allowed to see passwords. Please contact the team admin."

msgid "You cannot export logins, because you are not allowed to see passwords in these teams."
msgstr "You cannot export logins, because you are not allowed to see passwords in these teams."

msgid "You cannot remove your own account."
msgstr "You cannot remove your own account."

msgid "You do not have the permission to access managed organizations. To gain access, please contact your admin."
msgstr "You do not have the permission to access managed organizations. To gain access, please contact your admin."

msgid "You do not have the permission to create managed organizations."
msgstr "You do not have the permission to create managed organizations."

msgid "You do not have the permission to export logins from here. Please contact your organization admin."
msgstr "You do not have the permission to export logins from here. Please contact your organization admin."

#. placeholder {0}: targetVault.label
msgid "You do not have the permission to import logins to “{0}”. Select another location or contact your admin to get the required permission."
msgstr "You do not have the permission to import logins to “{0}”. Select another location or contact your admin to get the required permission."

#. placeholder {0}: selectedOrganization.name
msgid "You do not have the permission to redeem a coupon for {0}."
msgstr "You do not have the permission to redeem a coupon for {0}."

msgid "You don’t have the permission to remove users"
msgstr "You don’t have the permission to remove users"

msgid "You get your start code via email or from your admin."
msgstr "You get your start code via email or from your admin."

msgid "You have <0>{numberOfLogins}</0> personal {numberOfLogins, plural, one {login} other {logins}}"
msgstr "You have <0>{numberOfLogins}</0> personal {numberOfLogins, plural, one {login} other {logins}}"

msgid "You have <0>{numberOfLogins}</0> private {numberOfLogins, plural, one {login} other {logins}}"
msgstr "You have <0>{numberOfLogins}</0> private {numberOfLogins, plural, one {login} other {logins}}"

msgid "You have reached the maximum number of delegated admins for this organization. Please contact sales to increase your limit."
msgstr "You have reached the maximum number of delegated admins for this organization. Please contact sales to increase your limit."

msgid "You have reached the user count included in your license."
msgstr "You have reached the user count included in your license."

msgid "You have unsaved changes, really close?"
msgstr "You have unsaved changes, really close?"

msgid "You may close this window now"
msgstr "You may close this window now"

msgid "You may not join this organization because you already have another account."
msgstr "You may not join this organization because you already have another account."

msgid "You must be admin (delegated) of this organization to access it."
msgstr "You must be admin (delegated) of this organization to access it."

msgid "You must move or delete your <0>personal logins</0> before you can turn this organization into a managed organization."
msgstr "You must move or delete your <0>personal logins</0> before you can turn this organization into a managed organization."

msgid "You must verify your email address to activate your login inbox. Go to <0>Account settings</0> to verify your email address."
msgstr "You must verify your email address to activate your login inbox. Go to <0>Account settings</0> to verify your email address."

msgid "You need to export your data in the 1pux format. Follow the <0>1Password export guide</0> to export your data."
msgstr "You need to export your data in the 1pux format. Follow the <0>1Password export guide</0> to export your data."

msgid "You need to remove all delegated admins before converting to an independent organization"
msgstr "You need to remove all delegated admins before converting to an independent organization"

msgid "You received a confirmation via Email."
msgstr "You received a confirmation via Email."

msgid "You used a different security key. Please use the selected security key to enable connecting devices."
msgstr "You used a different security key. Please use the selected security key to enable connecting devices."

msgid "You were invited to this team by “{recentlyJoinedAddedByEmail}”."
msgstr "You were invited to this team by “{recentlyJoinedAddedByEmail}”."

msgid "You will be forwarded in a few seconds"
msgstr "You will be forwarded in a few seconds"

#. placeholder {0}: getLoginVaultLabel(vaultMetadata)
msgid "You will no longer be able to access this login in “{0}”."
msgstr "You will no longer be able to access this login in “{0}”."

#. placeholder {0}: childOrganization.name
msgid "You will no longer be able to manage “{0}”."
msgstr "You will no longer be able to manage “{0}”."

#. placeholder {0}: organization.name
msgid "You will no longer be able to manage {0} from this interface."
msgstr "You will no longer be able to manage {0} from this interface."

msgid "You will receive your start code from your organization admin."
msgstr "You will receive your start code from your organization admin."

msgid "You'll be able to unlock this device with it."
msgstr "You'll be able to unlock this device with it."

msgid "You'll be unable to undo this yourself."
msgstr "You'll be unable to undo this yourself."

msgid "You'll no longer be able to access logins."
msgstr "You'll no longer be able to access logins."

#. placeholder {0}: organization.name
msgid "You're about to join the organization “{0}”"
msgstr "You're about to join the organization “{0}”"

msgid "You’ve successfully <0/>set up heylogin"
msgstr "You’ve successfully <0/>set up heylogin"

msgid "You’ve successfully set up heylogin for Safari"
msgstr "You’ve successfully set up heylogin for Safari"

msgid "Your account is being set up. This may take up to a few minutes."
msgstr "Your account is being set up. This may take up to a few minutes."

msgid "Your backup code"
msgstr "Your backup code"

msgid "Your backup code can recover your account if you lose access to your login devices."
msgstr "Your backup code can recover your account if you lose access to your login devices."

msgid "Your browser ({browserDescription}) does not support additional login devices."
msgstr "Your browser ({browserDescription}) does not support additional login devices."

msgid "Your browser ({browserDescription}) has only restricted support for additional login devices."
msgstr "Your browser ({browserDescription}) has only restricted support for additional login devices."

msgid "Your browser does not support security keys."
msgstr "Your browser does not support security keys."

msgid "Your browser is not fully supported"
msgstr "Your browser is not fully supported"

msgid "Your browser is not fully supported."
msgstr "Your browser is not fully supported."

msgid "Your browser is out of date. Please update your browser to use heylogin."
msgstr "Your browser is out of date. Please update your browser to use heylogin."

msgid "Your browser was unable to access the security key. You may need to grant permissions in your operating system."
msgstr "Your browser was unable to access the security key. You may need to grant permissions in your operating system."

msgid "Your company (optional)"
msgstr "Your company (optional)"

msgid "Your contact"
msgstr "Your contact"

msgid "Your coupon code"
msgstr "Your coupon code"

msgid "Your download starts automatically. If not, click the button to download the exported data."
msgstr "Your download starts automatically. If not, click the button to download the exported data."

msgid "Your e-mail address has been confirmed"
msgstr "Your e-mail address has been confirmed"

msgid "Your email address"
msgstr "Your email address"

msgid "Your inbox link:"
msgstr "Your inbox link:"

msgid "Your login was transferred successfully"
msgstr "Your login was transferred successfully"

msgid "Your login will be saved automatically."
msgstr "Your login will be saved automatically."

msgid "Your logins will be added automatically"
msgstr "Your logins will be added automatically"

msgid "Your message"
msgstr "Your message"

msgid "Your name"
msgstr "Your name"

msgid "Your operating system/browser does not support the PRF extension or your security key does not support the HMAC-Secret extension. These are needed to connect devices."
msgstr "Your operating system/browser does not support the PRF extension or your security key does not support the HMAC-Secret extension. These are needed to connect devices."

msgid "Your organization has unpaid invoices. Please contact your administrator."
msgstr "Your organization has unpaid invoices. Please contact your administrator."

msgid "Your organization has unpaid invoices. Please resolve the outstanding balance."
msgstr "Your organization has unpaid invoices. Please resolve the outstanding balance."

msgid "Your organization only allows heylogin with the browser extension on devices managed by its administrators. Please contact your administrator."
msgstr "Your organization only allows heylogin with the browser extension on devices managed by its administrators. Please contact your administrator."

msgid "Your personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "Your personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."

msgid "Your previous backup code will be invalidated. Please write down the new backup code and keep it in a safe place."
msgstr "Your previous backup code will be invalidated. Please write down the new backup code and keep it in a safe place."

#. placeholder {0}: profileInfo.email
msgid "Your private account “{0}” and all its logins will be deleted."
msgstr "Your private account “{0}” and all its logins will be deleted."

msgid "Your private account is independent of all organizations you join."
msgstr "Your private account is independent of all organizations you join."

msgid "Your private account is separate from all organizations you are a member in."
msgstr "Your private account is separate from all organizations you are a member in."

#. placeholder {0}: orgMembershipStatus.name
msgid "Your private account is separate from the organization “{0}”."
msgstr "Your private account is separate from the organization “{0}”."

msgid "Your private logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "Your private logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."

msgid "Your security key does not support the HMAC-Secret extension, which is needed to connect devices."
msgstr "Your security key does not support the HMAC-Secret extension, which is needed to connect devices."

msgid "Your security key will be disconnected from this account."
msgstr "Your security key will be disconnected from this account."

msgid "Your trial ended on {trialEnd}."
msgstr "Your trial ended on {trialEnd}."

msgid "Your trial ends on {trialEnd}."
msgstr "Your trial ends on {trialEnd}."

msgctxt "KeeperImport"
msgid "Zip"
msgstr "Zip"
